var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 713,
    viewBox: "0 0 706 713",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_196)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 356.5,
    cy: 356.5,
    r: 142.5,
    fill: "#0F6BCD"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_196)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M301.84 672.671L348.282 711.024L312.274 631.276L301.84 672.671Z",
    stroke: "url(#paint0_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M172.172 361.96C221.234 430.077 271.752 496.092 320.993 564.064C301.387 578.995 314.619 556.558 320.993 564.064C298.912 582.569 275.457 597.613 252.843 614.776",
    stroke: "url(#paint1_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M167.287 188.455L287.217 212.59L272.594 137.743L167.287 188.455Z",
    stroke: "url(#paint2_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M320.912 564.064L358.246 506.509L176.135 502.546L320.912 564.064Z",
    stroke: "url(#paint3_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M167.287 188.455L176.136 502.546L97.6814 368.673L167.287 188.455Z",
    stroke: "url(#paint4_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M112.968 516.684L157.97 553.857L176.135 502.546L112.968 516.684Z",
    stroke: "url(#paint5_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M34.449 427.052L176.136 502.546L97.6814 368.673L34.449 427.052Z",
    stroke: "url(#paint6_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M119.859 112.217L167.287 188.455L157.857 21.6953L119.859 112.217Z",
    stroke: "url(#paint7_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M176.135 502.546L358.246 506.509L292.134 351.154L176.135 502.546Z",
    stroke: "url(#paint8_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M97.6814 368.673L292.134 351.154L176.136 502.546L97.6814 368.673Z",
    stroke: "url(#paint9_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M292.134 351.154L389.191 370.857L176.135 502.546L292.134 351.154Z",
    stroke: "url(#paint10_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M167.287 188.455L292.134 351.154L199.267 128.846L167.287 188.455Z",
    stroke: "url(#paint11_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M158.002 21.3233L199.267 128.846L257.436 10.1941L158.261 20.7247L158.002 21.3233Z",
    stroke: "url(#paint12_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M542.33 403.904L631.59 577.781L441.796 523.769L542.33 403.904Z",
    stroke: "url(#paint13_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M624.667 399.181L552.893 604.165L469.052 585.238L624.667 399.181Z",
    stroke: "url(#paint14_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M542.33 403.904L624.667 399.181",
    stroke: "url(#paint15_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M542.33 403.904L469.052 585.238L624.667 399.181L542.33 403.904Z",
    stroke: "url(#paint16_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M495.662 657.869L338.738 640.367L570.8 582.149L495.662 657.869Z",
    stroke: "url(#paint17_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M535.973 330.174L624.667 399.181",
    stroke: "url(#paint18_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M624.667 399.181L542.33 403.904L535.973 330.174L624.667 399.181Z",
    stroke: "url(#paint19_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M591.182 111.667L526.445 321.212L442.054 307.883L591.182 111.667Z",
    stroke: "url(#paint20_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.82,
    d: "M509.104 121.874L442.054 307.883L591.182 111.667L509.104 121.874Z",
    stroke: "url(#paint21_linear_0_196)",
    strokeWidth: 0.323522,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.623 365.971L106.805 462.041L203.311 513.271L343.623 365.971Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.332 171.421L280.892 172.812L444.546 110.534L371.332 171.421Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.43
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M523.986 309.598L433.562 310.989L597.216 248.711L523.986 309.598Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.43
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.267 128.846L341.73 53.7563L248.912 59.7739L199.267 128.846Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M13.9053 434.865L109.635 461.734L232.153 416.522L13.9053 434.865Z",
    fill: "url(#paint22_linear_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M399.285 344.166L271.413 274.479L150.771 326.291L399.285 344.166Z",
    fill: "url(#paint23_linear_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M404.477 445.218L681.315 446.642L542.33 403.904L404.477 445.218Z",
    fill: "url(#paint24_linear_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M105.915 510.861L159.07 554.763L280.941 476.875L105.915 510.861Z",
    fill: "url(#paint25_linear_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M165.411 182.842L223.774 80.3338L383.918 72.7795L165.411 182.842Z",
    fill: "url(#paint26_linear_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M419.699 288.989C420.023 288.634 425.701 293.341 432.397 299.488C439.094 305.635 444.238 310.892 443.915 311.248C443.591 311.604 437.913 306.896 431.233 300.749C424.552 294.602 419.376 289.41 419.699 288.989Z",
    fill: "url(#paint27_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M420.686 312.299C420.33 311.976 425.037 306.282 431.184 299.601C437.331 292.92 442.507 287.744 442.944 288.067C443.381 288.391 438.593 294.069 432.446 300.766C426.299 307.463 421.026 312.607 420.686 312.299Z",
    fill: "url(#paint28_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M406.661 301.251C406.661 300.523 417.855 299.455 431.75 298.873C445.646 298.291 456.936 298.388 456.969 299.116C457.001 299.843 445.759 300.911 431.863 301.493C417.968 302.076 406.693 301.93 406.661 301.251Z",
    fill: "url(#paint29_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M433.352 335.9C432.316 335.9 430.812 319.966 429.971 300.215C429.13 280.464 429.291 264.402 430.327 264.369C431.362 264.337 432.882 280.303 433.707 300.054C434.532 319.805 434.354 335.9 433.352 335.9Z",
    fill: "url(#paint30_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M217.126 278.717C217.368 278.459 221.736 282.066 226.831 286.805C231.927 291.545 235.922 295.573 235.68 295.832C235.437 296.091 231.07 292.499 225.974 287.744C220.879 282.988 216.883 278.992 217.126 278.717Z",
    fill: "url(#paint31_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M217.886 296.56C217.611 296.317 221.218 291.95 225.974 286.854C230.73 281.759 234.725 277.763 235 278.006C235.275 278.248 231.652 282.616 226.912 287.712C222.173 292.807 218.21 296.802 217.886 296.56Z",
    fill: "url(#paint32_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M207.113 288.084C207.113 287.517 215.718 286.709 226.379 286.256C237.039 285.803 245.709 285.9 245.79 286.45C245.871 287 237.184 287.825 226.524 288.278C215.864 288.731 207.129 288.634 207.113 288.084Z",
    fill: "url(#paint33_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M227.575 314.725C226.783 314.725 225.618 302.496 224.987 287.323C224.356 272.15 224.47 259.824 225.262 259.824C226.055 259.824 227.22 272.053 227.85 287.226C228.481 302.399 228.368 314.693 227.575 314.725Z",
    fill: "url(#paint34_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M304.137 533.426C304.331 533.2 307.841 536.112 311.982 539.897C316.123 543.682 319.294 546.95 319.1 547.176C318.906 547.403 315.395 544.491 311.254 540.706C307.113 536.92 303.943 533.637 304.137 533.426Z",
    fill: "url(#paint35_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M304.752 547.807C304.525 547.613 307.437 544.103 311.222 539.962C315.007 535.821 318.275 532.65 318.501 532.844C318.728 533.038 315.816 536.548 312.031 540.69C308.246 544.831 304.962 547.969 304.752 547.807Z",
    fill: "url(#paint36_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M296.081 540.948C296.081 540.495 303.005 539.848 311.578 539.476C320.151 539.104 327.139 539.185 327.156 539.638C327.172 540.091 320.232 540.738 311.659 541.11C303.086 541.482 296.097 541.337 296.081 540.948Z",
    fill: "url(#paint37_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M312.549 562.366C311.918 562.366 310.931 552.514 310.462 540.317C309.993 528.121 310.041 518.189 310.688 518.172C311.335 518.156 312.306 528.007 312.775 540.22C313.244 552.433 313.196 562.366 312.549 562.366Z",
    fill: "url(#paint38_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M416.674 221.05C416.901 220.807 420.928 224.139 425.668 228.491C430.408 232.842 434.08 236.579 433.853 236.837C433.627 237.096 429.583 233.748 424.843 229.396C420.103 225.045 416.448 221.341 416.674 221.05Z",
    fill: "url(#paint39_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M417.37 237.582C417.111 237.355 420.443 233.327 424.811 228.572C429.178 223.816 432.899 220.176 433.157 220.403C433.416 220.629 430.068 224.657 425.7 229.397C421.333 234.136 417.612 237.808 417.37 237.582Z",
    fill: "url(#paint40_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M407.47 229.752C407.47 229.235 415.412 228.474 425.264 228.135C435.115 227.795 443.057 227.811 443.154 228.313C443.252 228.814 435.196 229.591 425.361 230.011C415.526 230.432 407.47 230.254 407.47 229.752Z",
    fill: "url(#paint41_radial_0_196)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M426.331 254.356C425.603 254.356 424.519 243.033 423.937 229.041C423.355 215.048 423.452 203.644 424.18 203.628C424.908 203.612 425.992 214.951 426.59 228.944C427.189 242.936 427.059 254.324 426.331 254.356Z",
    fill: "url(#paint42_radial_0_196)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M491.586 348.841C491.586 349.339 491.388 349.816 491.036 350.168C490.684 350.52 490.207 350.717 489.709 350.717C489.212 350.717 488.734 350.52 488.382 350.168C488.03 349.816 487.833 349.339 487.833 348.841C487.835 348.54 487.907 348.245 488.045 347.978C488.183 347.711 488.382 347.48 488.625 347.304C488.907 347.105 489.237 346.987 489.581 346.964C489.925 346.94 490.268 347.012 490.574 347.171C490.879 347.329 491.136 347.569 491.314 347.864C491.493 348.158 491.587 348.496 491.586 348.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M375.118 208.109C375.113 208.241 375.078 208.371 375.017 208.489C374.955 208.606 374.868 208.708 374.762 208.788C374.672 208.852 374.57 208.898 374.463 208.922C374.355 208.946 374.244 208.949 374.135 208.929C374.026 208.909 373.923 208.868 373.83 208.808C373.738 208.748 373.659 208.669 373.597 208.578C373.516 208.435 373.482 208.271 373.5 208.109C373.498 207.975 373.53 207.843 373.592 207.724C373.654 207.606 373.745 207.504 373.856 207.429C373.981 207.345 374.127 207.296 374.277 207.287C374.428 207.279 374.578 207.311 374.712 207.381C374.846 207.45 374.959 207.554 375.039 207.682C375.119 207.811 375.163 207.958 375.166 208.109H375.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M485.115 162.444C485.113 162.62 485.055 162.792 484.95 162.933C484.845 163.075 484.698 163.181 484.53 163.234C484.362 163.288 484.181 163.287 484.013 163.233C483.845 163.178 483.699 163.071 483.595 162.929C483.497 162.792 483.446 162.628 483.449 162.46C483.449 162.324 483.481 162.19 483.543 162.069C483.605 161.948 483.695 161.844 483.805 161.764C483.892 161.7 483.992 161.655 484.098 161.633C484.204 161.611 484.314 161.611 484.42 161.635C484.527 161.652 484.63 161.691 484.722 161.749C484.814 161.807 484.893 161.884 484.954 161.974C485.055 162.11 485.112 162.274 485.115 162.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M160.234 532.666C160.234 532.8 160.202 532.931 160.14 533.05C160.078 533.168 159.988 533.269 159.878 533.345C159.789 533.41 159.687 533.455 159.579 533.479C159.472 533.504 159.36 533.506 159.252 533.486C159.143 533.467 159.039 533.426 158.947 533.365C158.855 533.305 158.775 533.227 158.714 533.135C158.618 532.998 158.567 532.834 158.568 532.666C158.568 532.53 158.6 532.396 158.662 532.275C158.724 532.154 158.814 532.05 158.924 531.97C159.013 531.909 159.114 531.865 159.22 531.842C159.326 531.82 159.435 531.818 159.542 531.837C159.649 531.857 159.75 531.897 159.841 531.956C159.932 532.015 160.011 532.091 160.073 532.181C160.176 532.321 160.233 532.491 160.234 532.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M252.81 325.191C252.809 325.325 252.776 325.456 252.714 325.574C252.652 325.692 252.563 325.794 252.454 325.871C252.366 325.936 252.265 325.982 252.158 326.008C252.051 326.033 251.94 326.037 251.831 326.019C251.723 326.001 251.619 325.961 251.526 325.903C251.433 325.844 251.353 325.767 251.29 325.677C251.188 325.535 251.131 325.366 251.128 325.191C251.134 325.071 251.164 324.952 251.218 324.844C251.272 324.736 251.347 324.64 251.44 324.562C251.533 324.485 251.641 324.427 251.757 324.394C251.873 324.36 251.995 324.351 252.115 324.366C252.328 324.412 252.517 324.532 252.648 324.706C252.749 324.849 252.805 325.017 252.81 325.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M219.827 371.876C219.823 372.332 219.711 372.781 219.5 373.186C219.289 373.591 218.985 373.94 218.614 374.205C218.307 374.422 217.961 374.576 217.595 374.658C217.228 374.741 216.849 374.75 216.479 374.685C216.11 374.621 215.756 374.483 215.44 374.282C215.123 374.08 214.849 373.817 214.634 373.509C214.313 373.048 214.135 372.501 214.123 371.939C214.112 371.376 214.267 370.823 214.57 370.348C214.873 369.874 215.31 369.5 215.825 369.274C216.34 369.048 216.911 368.979 217.465 369.077C218.21 369.207 218.872 369.626 219.309 370.242C219.647 370.72 219.827 371.291 219.827 371.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M321.526 478.897C321.522 479.5 321.327 480.087 320.967 480.572C320.608 481.057 320.105 481.415 319.529 481.595C318.953 481.775 318.334 481.767 317.763 481.573C317.192 481.379 316.697 481.008 316.35 480.514C316.011 480.043 315.83 479.477 315.832 478.897C315.842 478.294 316.042 477.71 316.403 477.228C316.764 476.745 317.268 476.389 317.844 476.21C318.419 476.031 319.036 476.038 319.607 476.23C320.178 476.422 320.675 476.789 321.025 477.279C321.347 477.758 321.521 478.32 321.526 478.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M536.604 474.917C536.607 475.263 536.534 475.605 536.39 475.919C536.245 476.233 536.034 476.511 535.769 476.733C535.505 476.956 535.195 477.117 534.861 477.206C534.527 477.295 534.178 477.309 533.838 477.247C533.532 477.195 533.24 477.083 532.979 476.916C532.718 476.749 532.493 476.532 532.317 476.276C532.029 475.888 531.876 475.417 531.88 474.934C531.877 474.588 531.95 474.246 532.095 473.932C532.239 473.618 532.451 473.34 532.715 473.118C532.979 472.895 533.29 472.734 533.623 472.645C533.957 472.556 534.307 472.542 534.647 472.604C535.191 472.702 535.684 472.986 536.041 473.409C536.399 473.831 536.598 474.364 536.604 474.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M294.399 612.511C294.436 613.134 294.345 613.758 294.132 614.345C293.919 614.932 293.589 615.469 293.161 615.923C292.733 616.377 292.217 616.739 291.644 616.986C291.071 617.234 290.453 617.361 289.829 617.361C289.205 617.361 288.587 617.234 288.015 616.986C287.442 616.739 286.925 616.377 286.497 615.923C286.069 615.469 285.739 614.932 285.526 614.345C285.313 613.758 285.222 613.134 285.259 612.511C285.264 611.542 285.577 610.599 286.153 609.819C286.728 609.038 287.536 608.461 288.461 608.169C289.386 607.878 290.379 607.887 291.298 608.197C292.217 608.506 293.014 609.099 293.574 609.891C294.109 610.66 294.397 611.574 294.399 612.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M553.573 218.267C553.569 219.335 553.19 220.367 552.504 221.184C551.817 222.002 550.866 222.552 549.815 222.741C548.765 222.929 547.681 222.743 546.753 222.214C545.826 221.686 545.113 220.849 544.739 219.85C544.364 218.85 544.353 217.751 544.705 216.743C545.058 215.736 545.753 214.884 546.669 214.336C547.585 213.788 548.664 213.578 549.719 213.744C550.773 213.91 551.736 214.44 552.44 215.242C553.173 216.08 553.575 217.155 553.573 218.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M466.869 282.923C466.799 284.088 466.288 285.183 465.438 285.983C464.589 286.783 463.466 287.229 462.299 287.229C461.132 287.229 460.009 286.783 459.159 285.983C458.31 285.183 457.798 284.088 457.729 282.923C457.725 281.951 458.031 281.004 458.603 280.218C459.175 279.432 459.983 278.85 460.909 278.555C461.836 278.261 462.832 278.27 463.752 278.582C464.673 278.893 465.47 279.49 466.027 280.287C466.577 281.056 466.871 281.978 466.869 282.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M341.924 374.722C341.915 375.325 341.715 375.909 341.354 376.391C340.993 376.874 340.489 377.23 339.913 377.409C339.338 377.589 338.721 377.582 338.149 377.39C337.578 377.198 337.082 376.83 336.732 376.34C336.41 375.862 336.236 375.299 336.23 374.722C336.23 373.967 336.53 373.243 337.064 372.709C337.598 372.175 338.322 371.875 339.077 371.875C339.833 371.875 340.557 372.175 341.091 372.709C341.624 373.243 341.924 373.967 341.924 374.722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M206.271 266.795C206.273 267.176 206.183 267.551 206.008 267.889C205.833 268.227 205.58 268.518 205.269 268.737C204.914 268.99 204.496 269.141 204.061 269.172C203.627 269.203 203.192 269.113 202.805 268.912C202.418 268.711 202.094 268.407 201.869 268.034C201.645 267.66 201.528 267.231 201.532 266.795C201.53 266.415 201.621 266.04 201.795 265.702C201.97 265.364 202.224 265.073 202.535 264.854C202.791 264.676 203.08 264.55 203.386 264.483C203.691 264.417 204.007 264.411 204.314 264.466C204.637 264.506 204.947 264.613 205.226 264.78C205.504 264.947 205.745 265.171 205.932 265.437C206.177 265.846 206.295 266.319 206.271 266.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M418.178 197.627C418.178 197.964 418.106 198.297 417.967 198.604C417.827 198.911 417.624 199.184 417.37 199.406C417.138 199.614 416.867 199.773 416.572 199.873C416.277 199.973 415.965 200.013 415.655 199.988C415.032 199.948 414.451 199.663 414.037 199.196C413.651 198.746 413.444 198.171 413.455 197.578C413.457 197.255 413.524 196.935 413.654 196.638C413.783 196.342 413.972 196.075 414.208 195.854C414.444 195.633 414.723 195.462 415.028 195.352C415.332 195.243 415.656 195.197 415.978 195.216C416.578 195.257 417.14 195.523 417.551 195.962C417.962 196.4 418.192 196.977 418.195 197.578L418.178 197.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M381.022 466.554C381.027 467.235 380.787 467.895 380.347 468.414C379.907 468.933 379.296 469.278 378.624 469.385C377.952 469.492 377.263 469.355 376.684 468.999C376.104 468.642 375.671 468.09 375.464 467.441C375.256 466.793 375.288 466.092 375.553 465.465C375.818 464.838 376.299 464.327 376.908 464.024C377.518 463.721 378.216 463.647 378.875 463.814C379.535 463.981 380.113 464.38 380.504 464.937C380.838 465.411 381.018 465.975 381.022 466.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M159.733 408.482C159.74 409.21 159.513 409.92 159.086 410.509C158.658 411.098 158.053 411.534 157.359 411.753C156.666 411.972 155.92 411.963 155.232 411.726C154.544 411.49 153.95 411.039 153.537 410.439C153.135 409.872 152.92 409.194 152.923 408.498C152.916 407.771 153.143 407.06 153.57 406.471C153.997 405.882 154.602 405.446 155.296 405.227C155.99 405.008 156.736 405.017 157.424 405.254C158.112 405.49 158.706 405.942 159.118 406.541C159.521 407.108 159.736 407.787 159.733 408.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M272.852 278.362C272.85 278.862 272.69 279.348 272.393 279.751C272.097 280.154 271.681 280.452 271.204 280.603C270.728 280.755 270.215 280.75 269.741 280.592C269.267 280.433 268.855 280.128 268.566 279.72C268.287 279.321 268.135 278.848 268.129 278.362C268.132 277.98 268.226 277.605 268.403 277.268C268.58 276.93 268.836 276.639 269.148 276.42C269.657 276.078 270.28 275.948 270.884 276.056C271.487 276.165 272.025 276.505 272.383 277.003C272.674 277.397 272.838 277.871 272.852 278.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M445.84 487.697C445.843 488.195 445.736 488.688 445.527 489.141C445.318 489.593 445.012 489.995 444.631 490.316C444.249 490.637 443.802 490.87 443.32 490.999C442.839 491.128 442.335 491.149 441.844 491.061C441.406 490.985 440.988 490.823 440.613 490.584C440.238 490.345 439.914 490.035 439.66 489.67C439.275 489.119 439.061 488.466 439.045 487.793C439.029 487.121 439.213 486.458 439.572 485.89C439.932 485.321 440.451 484.871 441.066 484.597C441.68 484.323 442.362 484.236 443.025 484.348C443.812 484.488 444.525 484.9 445.039 485.512C445.554 486.124 445.837 486.897 445.84 487.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M371.607 259.452C371.607 259.675 371.555 259.896 371.454 260.096C371.352 260.295 371.206 260.468 371.025 260.6C370.876 260.704 370.707 260.778 370.529 260.817C370.351 260.855 370.167 260.858 369.988 260.825C369.809 260.792 369.638 260.723 369.486 260.624C369.334 260.524 369.202 260.395 369.1 260.244C368.927 260.017 368.835 259.738 368.841 259.452C368.844 259.229 368.9 259.01 369.004 258.814C369.108 258.617 369.258 258.447 369.44 258.319C369.741 258.112 370.112 258.031 370.472 258.094C370.832 258.158 371.153 258.361 371.365 258.659C371.523 258.893 371.607 259.169 371.607 259.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M288.204 59.8546C288.194 60.4572 287.994 61.0412 287.633 61.5236C287.272 62.0061 286.768 62.3623 286.192 62.5415C285.617 62.7207 285 62.7139 284.429 62.5219C283.857 62.3299 283.361 61.9626 283.011 61.4722C282.689 60.9938 282.515 60.4313 282.51 59.8546C282.51 59.3975 282.62 58.9471 282.831 58.5417C283.043 58.1362 283.348 57.7876 283.723 57.5253C284.027 57.3107 284.371 57.1588 284.735 57.0783C285.099 56.9977 285.475 56.9902 285.842 57.0562C286.586 57.1859 287.249 57.6045 287.686 58.2208C288.023 58.6989 288.204 59.2696 288.204 59.8546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M135.711 232.373C135.716 233.345 135.409 234.292 134.837 235.078C134.265 235.864 133.457 236.446 132.531 236.741C131.605 237.035 130.609 237.026 129.688 236.714C128.767 236.403 127.97 235.806 127.413 235.009C126.871 234.243 126.583 233.327 126.588 232.389C126.587 231.418 126.896 230.473 127.469 229.69C128.042 228.907 128.851 228.327 129.776 228.035C130.701 227.743 131.696 227.753 132.615 228.065C133.534 228.377 134.33 228.973 134.886 229.768C135.43 230.528 135.718 231.439 135.711 232.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M573.275 303.839C573.275 304.594 572.975 305.318 572.441 305.852C571.907 306.386 571.183 306.686 570.428 306.686C569.673 306.686 568.949 306.386 568.415 305.852C567.881 305.318 567.581 304.594 567.581 303.839C567.581 303.084 567.881 302.36 568.415 301.826C568.949 301.292 569.673 300.992 570.428 300.992C571.183 300.992 571.907 301.292 572.441 301.826C572.975 302.36 573.275 303.084 573.275 303.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M74.5656 280.756C74.5615 281.359 74.3658 281.946 74.0068 282.431C73.6477 282.916 73.1438 283.274 72.5679 283.454C71.9919 283.634 71.3736 283.626 70.8023 283.432C70.231 283.238 69.7362 282.867 69.3892 282.373C69.0503 281.902 68.8691 281.336 68.8716 280.756C68.8814 280.153 69.0811 279.569 69.4422 279.087C69.8034 278.604 70.3075 278.248 70.8828 278.069C71.4581 277.89 72.0754 277.896 72.6466 278.088C73.2178 278.28 73.7138 278.648 74.0641 279.138C74.3861 279.616 74.5605 280.179 74.5656 280.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M602.974 188.584C602.971 188.877 602.875 189.162 602.7 189.398C602.525 189.634 602.28 189.808 602 189.896C601.72 189.984 601.419 189.981 601.141 189.888C600.863 189.794 600.621 189.616 600.451 189.377C600.289 189.144 600.204 188.867 600.208 188.584C600.205 188.362 600.257 188.143 600.358 187.945C600.46 187.748 600.608 187.578 600.79 187.452C601.092 187.243 601.464 187.161 601.826 187.225C602.005 187.254 602.176 187.319 602.329 187.416C602.482 187.513 602.614 187.641 602.715 187.791C602.883 188.022 602.973 188.299 602.974 188.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M192.328 193.372C192.341 193.688 192.274 194.003 192.133 194.286C191.991 194.569 191.78 194.811 191.519 194.99C191.104 195.279 190.594 195.395 190.095 195.313C189.607 195.217 189.174 194.939 188.882 194.537C188.66 194.219 188.541 193.841 188.542 193.453C188.533 193.138 188.602 192.825 188.743 192.542C188.884 192.26 189.093 192.017 189.351 191.836C189.641 191.64 189.979 191.528 190.328 191.511C190.677 191.494 191.024 191.574 191.331 191.74C191.638 191.907 191.893 192.155 192.069 192.457C192.245 192.759 192.334 193.104 192.328 193.453V193.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M189.092 520.113C189.092 520.615 188.893 521.097 188.538 521.452C188.183 521.807 187.702 522.006 187.2 522.006C186.698 522.006 186.217 521.807 185.862 521.452C185.507 521.097 185.307 520.615 185.307 520.113C185.298 519.798 185.367 519.485 185.508 519.203C185.649 518.92 185.858 518.678 186.116 518.496C186.32 518.353 186.55 518.252 186.793 518.199C187.036 518.145 187.287 518.14 187.532 518.184C187.777 518.227 188.01 518.319 188.22 518.453C188.429 518.587 188.611 518.761 188.753 518.965C188.988 519.3 189.108 519.704 189.092 520.113Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 329.979L396.147 355.069L344.626 381.193L381.572 329.979Z",
    fill: "url(#paint43_linear_0_196)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 310.148L423.403 217.086L337.072 173.637L354.93 310.148Z",
    fill: "url(#paint44_linear_0_196)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 245.378L354.93 310.148L337.072 173.637L272.933 245.378Z",
    fill: "url(#paint45_linear_0_196)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 245.379L337.072 173.637L234.337 160.179L272.933 245.379Z",
    fill: "url(#paint46_linear_0_196)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 160.179L272.933 245.379L189.254 240.137L234.337 160.179Z",
    fill: "url(#paint47_linear_0_196)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 173.638L423.403 217.087L430.359 149.487L337.072 173.638Z",
    fill: "url(#paint48_linear_0_196)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M423.404 217.086L438.366 312.784L490.777 224.317L423.404 217.086Z",
    fill: "url(#paint49_linear_0_196)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 358.417L511.66 379.656L445.257 458.143L448.784 358.417Z",
    fill: "url(#paint50_linear_0_196)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 458.143L448.784 358.417L394.48 414.613L445.257 458.143Z",
    fill: "url(#paint51_linear_0_196)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 381.193L396.147 355.069L394.481 414.613L344.626 381.193Z",
    fill: "url(#paint52_linear_0_196)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 449.149L392.2 461.653L352.811 462.866L374.325 449.149Z",
    fill: "url(#paint53_linear_0_196)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 444.442L374.325 449.149L352.811 462.866L339.627 444.442Z",
    fill: "url(#paint54_linear_0_196)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 472.248L392.2 461.653L352.811 462.866L350.255 472.248Z",
    fill: "url(#paint55_linear_0_196)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 444.442L352.811 462.866L326.056 462.154L339.627 444.442Z",
    fill: "url(#paint56_linear_0_196)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 472.248L352.811 462.866L326.056 462.155L350.255 472.248Z",
    fill: "url(#paint57_linear_0_196)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.286 606.834L271.17 514.743L208.763 494.863L305.286 606.834Z",
    fill: "url(#paint58_linear_0_196)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 336.919L189.254 240.137L171.46 352.675L198.038 336.919Z",
    fill: "url(#paint59_linear_0_196)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 352.675L189.254 240.138L172.205 230.949L171.46 352.675Z",
    fill: "url(#paint60_linear_0_196)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 240.137L234.337 160.179L172.205 230.949L189.254 240.137Z",
    fill: "url(#paint61_linear_0_196)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.205 230.949L234.337 160.179L245.579 136.934L172.205 230.949Z",
    fill: "url(#paint62_linear_0_196)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 160.179L337.072 173.637L245.58 136.934L234.337 160.179Z",
    fill: "url(#paint63_linear_0_196)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.58 136.934L337.072 173.638L316.706 119.237L245.58 136.934Z",
    fill: "url(#paint64_linear_0_196)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 173.638L430.359 149.487L316.706 119.237L337.072 173.638Z",
    fill: "url(#paint65_linear_0_196)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.706 119.237L430.359 149.487L445.063 132.712L316.706 119.237Z",
    fill: "url(#paint66_linear_0_196)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 312.784L490.777 224.317L512.275 265.275L438.366 312.784Z",
    fill: "url(#paint67_linear_0_196)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M423.404 217.087L430.359 149.487L499.917 206.75L423.404 217.087Z",
    fill: "url(#paint68_linear_0_196)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M423.404 217.087L490.777 224.317L499.917 206.75L423.404 217.087Z",
    fill: "url(#paint69_linear_0_196)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M430.359 149.487L445.063 132.712L499.916 206.75L430.359 149.487Z",
    fill: "url(#paint70_linear_0_196)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M490.777 224.317L512.275 265.275L499.916 206.75L490.777 224.317Z",
    fill: "url(#paint71_linear_0_196)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 511.831L415.558 581.825L469.893 505.167L424.487 511.831Z",
    fill: "url(#paint72_linear_0_196)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 511.831L445.257 458.143L469.894 505.167L424.487 511.831Z",
    fill: "url(#paint73_linear_0_196)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 458.143L511.66 379.656L469.894 505.167L445.257 458.143Z",
    fill: "url(#paint74_linear_0_196)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 543.698L355.076 534.09L363.989 534.316L347.052 543.698Z",
    fill: "url(#paint75_linear_0_196)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 514.258L348.783 519.483L353.409 515.665L342.814 514.258Z",
    fill: "url(#paint76_linear_0_196)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 519.483L359.071 523.252L353.409 515.665L348.783 519.483Z",
    fill: "url(#paint77_linear_0_196)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 511.492L298.799 510.667L298.605 520.097L295.467 511.492Z",
    fill: "url(#paint78_linear_0_196)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M305.285 606.833L271.17 514.743L288.495 521.019L305.285 606.833Z",
    fill: "url(#paint79_linear_0_196)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 514.743L282.412 517.38L288.495 521.019L271.17 514.743Z",
    fill: "url(#paint80_linear_0_196)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 511.492L298.605 520.097L288.495 521.019L295.467 511.492Z",
    fill: "url(#paint81_linear_0_196)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 520.097L315.444 529.819L288.495 521.019L298.605 520.097Z",
    fill: "url(#paint82_linear_0_196)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 529.819L327.56 516.167L327.172 523.527L315.444 529.819Z",
    fill: "url(#paint83_linear_0_196)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 535.82L347.052 543.698L340.824 529.884L327.236 535.82Z",
    fill: "url(#paint84_linear_0_196)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 514.258L348.783 519.483L340.824 529.884L342.814 514.258Z",
    fill: "url(#paint85_linear_0_196)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 543.698L355.076 534.09L340.824 529.884L347.052 543.698Z",
    fill: "url(#paint86_linear_0_196)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 529.884L348.783 519.483L350.174 526.147L340.824 529.884Z",
    fill: "url(#paint87_linear_0_196)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 529.884L355.076 534.09L350.174 526.147L340.824 529.884Z",
    fill: "url(#paint88_linear_0_196)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 519.483L359.071 523.252L350.174 526.147L348.783 519.483Z",
    fill: "url(#paint89_linear_0_196)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 534.09L359.071 523.252L350.174 526.147L355.075 534.09Z",
    fill: "url(#paint90_linear_0_196)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M384.387 516.781L391.504 514.565L389.854 519.418L384.387 516.781Z",
    fill: "url(#paint91_linear_0_196)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 514.565L391.812 517.93L389.854 519.418L391.504 514.565Z",
    fill: "url(#paint92_linear_0_196)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 523.527L327.56 516.167L328.498 520.793L327.172 523.527Z",
    fill: "url(#paint93_linear_0_196)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 523.527L340.825 529.884L328.498 520.793L327.172 523.527Z",
    fill: "url(#paint94_linear_0_196)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 516.166L338.544 510.456L328.498 520.793L327.56 516.166Z",
    fill: "url(#paint95_linear_0_196)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 510.456L342.814 514.258L328.498 520.793L338.543 510.456Z",
    fill: "url(#paint96_linear_0_196)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 529.884L342.814 514.258L328.498 520.793L340.824 529.884Z",
    fill: "url(#paint97_linear_0_196)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 516.474L384.387 516.781L373.371 504.957V516.474Z",
    fill: "url(#paint98_linear_0_196)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 510.456L342.814 514.258L341.973 510.683L338.543 510.456Z",
    fill: "url(#paint99_linear_0_196)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 516.167L338.544 510.456L324.729 508.046L327.56 516.167Z",
    fill: "url(#paint100_linear_0_196)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 520.097L298.799 510.667L305.091 507.998L298.605 520.097Z",
    fill: "url(#paint101_linear_0_196)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 520.097L315.444 529.819L305.091 507.998L298.605 520.097Z",
    fill: "url(#paint102_linear_0_196)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 511.492L298.799 510.667L299.511 509.809L295.467 511.492Z",
    fill: "url(#paint103_linear_0_196)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M298.799 510.667L305.091 507.998L299.511 509.809L298.799 510.667Z",
    fill: "url(#paint104_linear_0_196)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 507.998L315.444 529.819L312.84 506.784L305.091 507.998Z",
    fill: "url(#paint105_linear_0_196)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 529.819L327.56 516.167L312.84 506.784L315.444 529.819Z",
    fill: "url(#paint106_linear_0_196)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 508.046L327.56 516.167L312.84 506.784L324.729 508.046Z",
    fill: "url(#paint107_linear_0_196)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 508.046L325.392 503.808L337.298 505.345L324.729 508.046Z",
    fill: "url(#paint108_linear_0_196)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 508.046L338.544 510.456L337.298 505.345L324.729 508.046Z",
    fill: "url(#paint109_linear_0_196)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 510.456L341.973 510.683L337.298 505.345L338.543 510.456Z",
    fill: "url(#paint110_linear_0_196)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 505.345L341.973 510.683L344.658 505.717L337.298 505.345Z",
    fill: "url(#paint111_linear_0_196)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M341.973 510.683L342.814 514.258L344.658 505.717L341.973 510.683Z",
    fill: "url(#paint112_linear_0_196)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 514.258L353.409 515.665L344.658 505.717L342.814 514.258Z",
    fill: "url(#paint113_linear_0_196)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 505.717L353.409 515.665L357.68 505.07L344.658 505.717Z",
    fill: "url(#paint114_linear_0_196)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 516.474V504.957L358.877 512.543L373.371 516.474Z",
    fill: "url(#paint115_linear_0_196)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 515.665L359.071 523.252L358.877 512.543L353.409 515.665Z",
    fill: "url(#paint116_linear_0_196)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 515.665L357.68 505.07L358.877 512.543L353.409 515.665Z",
    fill: "url(#paint117_linear_0_196)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 523.252L370.152 524.336L358.877 512.543L359.071 523.252Z",
    fill: "url(#paint118_linear_0_196)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 505.07L359.33 503.08L358.877 512.543L357.68 505.07Z",
    fill: "url(#paint119_linear_0_196)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 503.08L373.371 504.957L358.877 512.543L359.33 503.08Z",
    fill: "url(#paint120_linear_0_196)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 524.336L373.371 516.474L358.877 512.543L370.152 524.336Z",
    fill: "url(#paint121_linear_0_196)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 505.345L344.658 505.717L346.34 498.243L337.298 505.345Z",
    fill: "url(#paint122_linear_0_196)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 505.717L357.68 505.07L346.34 498.243L344.658 505.717Z",
    fill: "url(#paint123_linear_0_196)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 505.07L359.33 503.08L346.341 498.243L357.68 505.07Z",
    fill: "url(#paint124_linear_0_196)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 503.808L337.298 505.345L337.557 493.811L325.392 503.808Z",
    fill: "url(#paint125_linear_0_196)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 462.155L350.255 472.248L337.557 493.811L326.056 462.155Z",
    fill: "url(#paint126_linear_0_196)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 505.345L346.34 498.243L337.557 493.811L337.298 505.345Z",
    fill: "url(#paint127_linear_0_196)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 498.244L350.255 472.249L337.557 493.811L346.34 498.244Z",
    fill: "url(#paint128_linear_0_196)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 507.998L312.84 506.784L313.907 501.188L305.091 507.998Z",
    fill: "url(#paint129_linear_0_196)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M312.84 506.784L324.729 508.046L313.907 501.188L312.84 506.784Z",
    fill: "url(#paint130_linear_0_196)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 508.046L325.392 503.808L313.907 501.188L324.729 508.046Z",
    fill: "url(#paint131_linear_0_196)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 503.808L337.557 493.811L313.907 501.187L325.392 503.808Z",
    fill: "url(#paint132_linear_0_196)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 462.155L337.557 493.811L313.907 501.187L326.056 462.155Z",
    fill: "url(#paint133_linear_0_196)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M282.412 517.38L288.495 521.019L292.668 509.389L282.412 517.38Z",
    fill: "url(#paint134_linear_0_196)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 521.019L295.467 511.492L292.668 509.389L288.495 521.019Z",
    fill: "url(#paint135_linear_0_196)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 511.492L299.511 509.809L292.668 509.389L295.467 511.492Z",
    fill: "url(#paint136_linear_0_196)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M299.511 509.809L305.091 507.998L292.668 509.389L299.511 509.809Z",
    fill: "url(#paint137_linear_0_196)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 507.998L313.907 501.188L292.668 509.389L305.091 507.998Z",
    fill: "url(#paint138_linear_0_196)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 514.743L282.412 517.38L280.73 510.473L271.17 514.743Z",
    fill: "url(#paint139_linear_0_196)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M282.413 517.38L292.668 509.389L280.73 510.472L282.413 517.38Z",
    fill: "url(#paint140_linear_0_196)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M346.341 498.244L350.255 472.249L361.028 495.866L346.341 498.244Z",
    fill: "url(#paint141_linear_0_196)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M346.341 498.243L359.33 503.08L361.028 495.865L346.341 498.243Z",
    fill: "url(#paint142_linear_0_196)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 472.248L392.2 461.653L361.028 495.866L350.255 472.248Z",
    fill: "url(#paint143_linear_0_196)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 503.08L373.371 504.957L365.461 498.599L359.33 503.08Z",
    fill: "url(#paint144_linear_0_196)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 503.08L361.028 495.865L365.461 498.599L359.33 503.08Z",
    fill: "url(#paint145_linear_0_196)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M365.461 498.599L373.371 504.957L372.303 501.915L365.461 498.599Z",
    fill: "url(#paint146_linear_0_196)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 504.957L384.387 516.781L385.017 503.63L373.371 504.957Z",
    fill: "url(#paint147_linear_0_196)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M384.387 516.781L391.504 514.565L385.018 503.63L384.387 516.781Z",
    fill: "url(#paint148_linear_0_196)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M385.018 503.63L391.504 514.565L398.153 507.157L385.018 503.63Z",
    fill: "url(#paint149_linear_0_196)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 461.653L398.153 507.156L406.418 508.758L392.2 461.653Z",
    fill: "url(#paint150_linear_0_196)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M398.153 507.156L401.776 509.437L406.419 508.758L398.153 507.156Z",
    fill: "url(#paint151_linear_0_196)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 509.437L406.564 513.19L406.418 508.758L401.776 509.437Z",
    fill: "url(#paint152_linear_0_196)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 513.19L406.418 508.758L410.64 512.042L406.564 513.19Z",
    fill: "url(#paint153_linear_0_196)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 508.758L424.487 511.831L410.64 512.042L406.418 508.758Z",
    fill: "url(#paint154_linear_0_196)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 514.565L398.153 507.156L401.064 516.053L391.504 514.565Z",
    fill: "url(#paint155_linear_0_196)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M398.153 507.156L401.776 509.437L401.064 516.053L398.153 507.156Z",
    fill: "url(#paint156_linear_0_196)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 509.437L406.564 513.19L401.064 516.053L401.776 509.437Z",
    fill: "url(#paint157_linear_0_196)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 519.418L391.812 517.93L394.739 518.447L389.854 519.418Z",
    fill: "url(#paint158_linear_0_196)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M391.812 517.93L391.504 514.565L394.739 518.447L391.812 517.93Z",
    fill: "url(#paint159_linear_0_196)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 514.565L401.064 516.053L394.739 518.447L391.504 514.565Z",
    fill: "url(#paint160_linear_0_196)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 516.474L384.387 516.781L386.91 521.521L373.371 516.474Z",
    fill: "url(#paint161_linear_0_196)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M384.387 516.781L389.854 519.418L386.91 521.521L384.387 516.781Z",
    fill: "url(#paint162_linear_0_196)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 524.335L373.371 516.474L386.91 521.521L370.152 524.335Z",
    fill: "url(#paint163_linear_0_196)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M355.076 534.09L359.071 523.252L365.865 528.913L355.076 534.09Z",
    fill: "url(#paint164_linear_0_196)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M355.076 534.09L363.989 534.316L365.865 528.913L355.076 534.09Z",
    fill: "url(#paint165_linear_0_196)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 523.252L370.152 524.335L365.865 528.913L359.071 523.252Z",
    fill: "url(#paint166_linear_0_196)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 337.032L256.288 338.973L262.354 325.078L248.799 337.032Z",
    fill: "url(#paint167_linear_0_196)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 320.581L271.704 321.358L264.586 323.574L268.76 320.581Z",
    fill: "url(#paint168_linear_0_196)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 240.137L272.933 245.378L256.579 313.302L189.254 240.137Z",
    fill: "url(#paint169_linear_0_196)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 325.078L264.587 323.574L256.579 313.302L262.354 325.078Z",
    fill: "url(#paint170_linear_0_196)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M264.587 323.574L268.76 320.581L256.579 313.302L264.587 323.574Z",
    fill: "url(#paint171_linear_0_196)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 240.137L256.579 313.302L238.543 322.005L189.254 240.137Z",
    fill: "url(#paint172_linear_0_196)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 338.844L244.479 338.472L238.543 322.005L237.443 338.844Z",
    fill: "url(#paint173_linear_0_196)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M244.48 338.472L248.799 337.032L238.543 322.005L244.48 338.472Z",
    fill: "url(#paint174_linear_0_196)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 337.032L262.354 325.078L238.543 322.005L248.799 337.032Z",
    fill: "url(#paint175_linear_0_196)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 313.302L262.354 325.078L238.543 322.005L256.579 313.302Z",
    fill: "url(#paint176_linear_0_196)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 336.919L189.254 240.137L221.073 328.556L198.038 336.919Z",
    fill: "url(#paint177_linear_0_196)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 240.137L238.543 322.005L221.073 328.556L189.254 240.137Z",
    fill: "url(#paint178_linear_0_196)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 338.844L238.543 322.005L221.073 328.556L237.443 338.844Z",
    fill: "url(#paint179_linear_0_196)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 336.919L221.073 328.556L208.148 336.013L198.038 336.919Z",
    fill: "url(#paint180_linear_0_196)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 338.472L248.799 337.032L255.075 342.742L244.479 338.472Z",
    fill: "url(#paint181_linear_0_196)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 337.032L256.288 338.973L255.075 342.742L248.799 337.032Z",
    fill: "url(#paint182_linear_0_196)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 338.973L264.117 344.538L255.075 342.742L256.288 338.973Z",
    fill: "url(#paint183_linear_0_196)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 338.973L262.354 325.078L270.943 336.078L256.288 338.973Z",
    fill: "url(#paint184_linear_0_196)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 338.973L264.117 344.538L270.943 336.078L256.288 338.973Z",
    fill: "url(#paint185_linear_0_196)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 325.078L264.586 323.574L270.944 336.078L262.354 325.078Z",
    fill: "url(#paint186_linear_0_196)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M264.586 323.574L271.704 321.358L270.944 336.078L264.586 323.574Z",
    fill: "url(#paint187_linear_0_196)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 331.354L300.708 344.101L270.944 336.078L294.059 331.354Z",
    fill: "url(#paint188_linear_0_196)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 313.302L268.76 320.581L278.805 318.883L256.579 313.302Z",
    fill: "url(#paint189_linear_0_196)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 313.302L272.933 245.378L278.805 318.883L256.579 313.302Z",
    fill: "url(#paint190_linear_0_196)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 320.581L271.704 321.358L278.805 318.883L268.76 320.581Z",
    fill: "url(#paint191_linear_0_196)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 336.078L271.704 321.358L278.805 318.883L270.944 336.078Z",
    fill: "url(#paint192_linear_0_196)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 336.078L294.059 331.355L278.805 318.883L270.944 336.078Z",
    fill: "url(#paint193_linear_0_196)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 318.883L272.933 245.378L286.796 317.637L278.805 318.883Z",
    fill: "url(#paint194_linear_0_196)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 318.883L294.059 331.355L286.796 317.637L278.805 318.883Z",
    fill: "url(#paint195_linear_0_196)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 245.378L354.93 310.148L302.794 323.768L272.933 245.378Z",
    fill: "url(#paint196_linear_0_196)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 245.378L286.796 317.637L302.794 323.768L272.933 245.378Z",
    fill: "url(#paint197_linear_0_196)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M286.796 317.637L294.059 331.355L302.794 323.768L286.796 317.637Z",
    fill: "url(#paint198_linear_0_196)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 335.237L354.93 310.148L302.794 323.768L320.572 335.237Z",
    fill: "url(#paint199_linear_0_196)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 331.354L300.708 344.101L309.038 332.099L294.059 331.354Z",
    fill: "url(#paint200_linear_0_196)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 331.355L302.794 323.768L309.038 332.099L294.059 331.355Z",
    fill: "url(#paint201_linear_0_196)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M302.794 323.768L320.572 335.237L309.038 332.099L302.794 323.768Z",
    fill: "url(#paint202_linear_0_196)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 344.101L309.038 332.099L310.219 333.554L300.708 344.101Z",
    fill: "url(#paint203_linear_0_196)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M309.038 332.099L320.572 335.237L310.219 333.554L309.038 332.099Z",
    fill: "url(#paint204_linear_0_196)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 344.101L307.097 359.744L317.579 339.701L300.708 344.101Z",
    fill: "url(#paint205_linear_0_196)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 344.101L310.219 333.554L317.579 339.701L300.708 344.101Z",
    fill: "url(#paint206_linear_0_196)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M310.219 333.554L320.572 335.237L317.579 339.701L310.219 333.554Z",
    fill: "url(#paint207_linear_0_196)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 359.744L317.579 339.701L326.589 340.979L307.097 359.744Z",
    fill: "url(#paint208_linear_0_196)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M317.579 339.701L320.572 335.237L326.589 340.979L317.579 339.701Z",
    fill: "url(#paint209_linear_0_196)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 310.148L381.572 329.98L332.008 343.098L354.93 310.148Z",
    fill: "url(#paint210_linear_0_196)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 359.744L326.589 340.979L332.008 343.098L307.097 359.744Z",
    fill: "url(#paint211_linear_0_196)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 359.744L344.626 381.193L332.008 343.098L307.097 359.744Z",
    fill: "url(#paint212_linear_0_196)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 335.237L354.93 310.148L332.009 343.098L320.572 335.237Z",
    fill: "url(#paint213_linear_0_196)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 335.237L326.59 340.979L332.009 343.098L320.572 335.237Z",
    fill: "url(#paint214_linear_0_196)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 381.193L381.572 329.979L332.008 343.098L344.626 381.193Z",
    fill: "url(#paint215_linear_0_196)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 344.101L307.097 359.744L302.39 356.767L300.708 344.101Z",
    fill: "url(#paint216_linear_0_196)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M302.39 356.767L307.097 359.744L276.46 368.01L302.39 356.767Z",
    fill: "url(#paint217_linear_0_196)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 364.871L255.075 342.742L268.533 352.772L253.409 364.871Z",
    fill: "url(#paint218_linear_0_196)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 364.871L276.46 368.01L268.533 352.772L253.409 364.871Z",
    fill: "url(#paint219_linear_0_196)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M255.075 342.742L264.117 344.538L268.533 352.772L255.075 342.742Z",
    fill: "url(#paint220_linear_0_196)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M264.117 344.538L270.944 336.078L268.533 352.772L264.117 344.538Z",
    fill: "url(#paint221_linear_0_196)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M270.944 336.078L300.708 344.101L268.533 352.772L270.944 336.078Z",
    fill: "url(#paint222_linear_0_196)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 368.01L302.39 356.767L268.533 352.772L276.46 368.01Z",
    fill: "url(#paint223_linear_0_196)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 344.101L302.39 356.767L268.533 352.772L300.708 344.101Z",
    fill: "url(#paint224_linear_0_196)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 338.844L244.479 338.472L239.966 343.584L237.443 338.844Z",
    fill: "url(#paint225_linear_0_196)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 338.472L255.075 342.742L239.966 343.584L244.479 338.472Z",
    fill: "url(#paint226_linear_0_196)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 364.871L255.075 342.742L239.966 343.584L253.409 364.871Z",
    fill: "url(#paint227_linear_0_196)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 338.844L239.966 343.584L232.024 342.484L237.443 338.844Z",
    fill: "url(#paint228_linear_0_196)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 310.148L381.572 329.98L401.534 322.15L354.93 310.148Z",
    fill: "url(#paint229_linear_0_196)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 310.148L423.404 217.086L401.534 322.15L354.93 310.148Z",
    fill: "url(#paint230_linear_0_196)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 329.979L396.147 355.069L390.679 329.413L381.572 329.979Z",
    fill: "url(#paint231_linear_0_196)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 329.98L401.533 322.15L390.679 329.413L381.572 329.98Z",
    fill: "url(#paint232_linear_0_196)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 343.875L444.756 337.065L447.975 346.722L433.077 343.875Z",
    fill: "url(#paint233_linear_0_196)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M420.023 341.4L433.077 343.875L423.42 344.231L420.023 341.4Z",
    fill: "url(#paint234_linear_0_196)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 329.413L396.147 355.069L394.594 329.316L390.679 329.413Z",
    fill: "url(#paint235_linear_0_196)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 329.413L401.533 322.15L394.594 329.316L390.679 329.413Z",
    fill: "url(#paint236_linear_0_196)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 322.15L404.154 327.925L394.594 329.316L401.533 322.15Z",
    fill: "url(#paint237_linear_0_196)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 322.15L404.154 327.925L422.319 314.774L401.533 322.15Z",
    fill: "url(#paint238_linear_0_196)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 322.15L423.403 217.086L422.319 314.774L401.533 322.15Z",
    fill: "url(#paint239_linear_0_196)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 327.925L420.023 341.4L422.32 314.774L404.154 327.925Z",
    fill: "url(#paint240_linear_0_196)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 217.086L438.366 312.784L422.32 314.774L423.403 217.086Z",
    fill: "url(#paint241_linear_0_196)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M420.023 341.4L422.32 314.774L436.215 317.961L420.023 341.4Z",
    fill: "url(#paint242_linear_0_196)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M420.023 341.4L433.077 343.875L436.215 317.961L420.023 341.4Z",
    fill: "url(#paint243_linear_0_196)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M422.32 314.774L438.366 312.784L436.215 317.961L422.32 314.774Z",
    fill: "url(#paint244_linear_0_196)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 343.875L444.756 337.065L436.215 317.961L433.077 343.875Z",
    fill: "url(#paint245_linear_0_196)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 312.784L456.241 331.047L436.215 317.961L438.366 312.784Z",
    fill: "url(#paint246_linear_0_196)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 337.065L456.241 331.047L436.215 317.961L444.756 337.065Z",
    fill: "url(#paint247_linear_0_196)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 331.047L461.708 333.7L461.514 328.75L456.241 331.047Z",
    fill: "url(#paint248_linear_0_196)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 333.7L461.514 328.75L482.381 333.652L461.708 333.7Z",
    fill: "url(#paint249_linear_0_196)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 337.065L447.975 346.722L453.07 342.322L444.756 337.065Z",
    fill: "url(#paint250_linear_0_196)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 337.065L456.241 331.047L453.07 342.322L444.756 337.065Z",
    fill: "url(#paint251_linear_0_196)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 358.417L447.975 346.722L453.07 342.322L448.784 358.417Z",
    fill: "url(#paint252_linear_0_196)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 331.047L461.708 333.7L453.07 342.322L456.241 331.047Z",
    fill: "url(#paint253_linear_0_196)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 343.875L447.975 346.722L433.158 347.789L433.077 343.875Z",
    fill: "url(#paint254_linear_0_196)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 358.417L447.975 346.722L433.158 347.79L448.784 358.417Z",
    fill: "url(#paint255_linear_0_196)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M396.147 355.069L394.594 329.316L409.718 340.235L396.147 355.069Z",
    fill: "url(#paint256_linear_0_196)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M394.594 329.316L404.154 327.925L409.718 340.235L394.594 329.316Z",
    fill: "url(#paint257_linear_0_196)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 327.925L420.023 341.4L409.718 340.235L404.154 327.925Z",
    fill: "url(#paint258_linear_0_196)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 414.613L396.147 355.069L424.697 346.738L394.48 414.613Z",
    fill: "url(#paint259_linear_0_196)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 414.613L448.784 358.417L424.697 346.738L394.48 414.613Z",
    fill: "url(#paint260_linear_0_196)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M396.147 355.069L409.718 340.235L424.698 346.738L396.147 355.069Z",
    fill: "url(#paint261_linear_0_196)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M409.719 340.235L420.023 341.4L424.698 346.738L409.719 340.235Z",
    fill: "url(#paint262_linear_0_196)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M420.023 341.4L423.42 344.231L424.698 346.738L420.023 341.4Z",
    fill: "url(#paint263_linear_0_196)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M423.42 344.231L433.077 343.875L424.698 346.738L423.42 344.231Z",
    fill: "url(#paint264_linear_0_196)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M433.158 347.789L433.077 343.875L424.698 346.738L433.158 347.789Z",
    fill: "url(#paint265_linear_0_196)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M433.158 347.789L448.784 358.417L424.698 346.738L433.158 347.789Z",
    fill: "url(#paint266_linear_0_196)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 368.01L307.097 359.744L316.884 438.91L276.46 368.01Z",
    fill: "url(#paint267_linear_0_196)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 455.441L326.056 462.154L316.884 438.909L307.663 455.441Z",
    fill: "url(#paint268_linear_0_196)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 359.744L344.626 381.193L316.884 438.91L307.097 359.744Z",
    fill: "url(#paint269_linear_0_196)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 462.154L339.627 444.442L316.884 438.909L326.056 462.154Z",
    fill: "url(#paint270_linear_0_196)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 514.743L280.73 510.473L298.96 451.786L271.17 514.743Z",
    fill: "url(#paint271_linear_0_196)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M280.73 510.473L292.668 509.389L298.961 451.786L280.73 510.473Z",
    fill: "url(#paint272_linear_0_196)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 368.01L316.884 438.909L298.961 451.786L276.46 368.01Z",
    fill: "url(#paint273_linear_0_196)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 455.441L316.884 438.909L298.961 451.786L307.663 455.441Z",
    fill: "url(#paint274_linear_0_196)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 438.91L339.627 444.442L356.305 426.438L316.884 438.91Z",
    fill: "url(#paint275_linear_0_196)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 438.909L344.626 381.193L356.305 426.438L316.884 438.909Z",
    fill: "url(#paint276_linear_0_196)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 444.442L374.325 449.149L356.305 426.438L339.627 444.442Z",
    fill: "url(#paint277_linear_0_196)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 381.193L394.481 414.613L356.305 426.438L344.626 381.193Z",
    fill: "url(#paint278_linear_0_196)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 449.149L392.2 461.653L381.459 435.416L374.325 449.149Z",
    fill: "url(#paint279_linear_0_196)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 426.438L374.325 449.149L381.459 435.415L356.305 426.438Z",
    fill: "url(#paint280_linear_0_196)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 426.438L394.481 414.613L381.459 435.415L356.305 426.438Z",
    fill: "url(#paint281_linear_0_196)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 461.653L406.418 508.758L404.898 451.608L392.2 461.653Z",
    fill: "url(#paint282_linear_0_196)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 508.758L424.487 511.831L404.898 451.608L406.418 508.758Z",
    fill: "url(#paint283_linear_0_196)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 511.831L445.257 458.143L404.898 451.608L424.487 511.831Z",
    fill: "url(#paint284_linear_0_196)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 509.389L298.961 451.786L305.383 456.169L292.668 509.389Z",
    fill: "url(#paint285_linear_0_196)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 509.389L313.907 501.188L305.383 456.169L292.668 509.389Z",
    fill: "url(#paint286_linear_0_196)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M298.961 451.786L307.663 455.441L305.383 456.169L298.961 451.786Z",
    fill: "url(#paint287_linear_0_196)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 455.441L326.056 462.154L305.383 456.169L307.663 455.441Z",
    fill: "url(#paint288_linear_0_196)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M313.907 501.188L326.056 462.155L305.383 456.169L313.907 501.188Z",
    fill: "url(#paint289_linear_0_196)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 435.416L392.2 461.653L404.332 445.38L381.459 435.416Z",
    fill: "url(#paint290_linear_0_196)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 435.415L394.481 414.613L404.332 445.38L381.459 435.415Z",
    fill: "url(#paint291_linear_0_196)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 461.653L404.898 451.608L404.332 445.38L392.2 461.653Z",
    fill: "url(#paint292_linear_0_196)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 414.613L445.257 458.143L404.332 445.38L394.48 414.613Z",
    fill: "url(#paint293_linear_0_196)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M404.898 451.608L445.257 458.143L404.332 445.38L404.898 451.608Z",
    fill: "url(#paint294_linear_0_196)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 358.417L453.07 342.322L481.492 344.198L448.784 358.417Z",
    fill: "url(#paint295_linear_0_196)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 358.417L511.66 379.656L481.492 344.198L448.784 358.417Z",
    fill: "url(#paint296_linear_0_196)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M453.07 342.322L461.708 333.7L481.492 344.198L453.07 342.322Z",
    fill: "url(#paint297_linear_0_196)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 333.7L482.382 333.652L481.492 344.198L461.708 333.7Z",
    fill: "url(#paint298_linear_0_196)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 333.652L484.193 339.249L481.492 344.198L482.381 333.652Z",
    fill: "url(#paint299_linear_0_196)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 312.784L456.241 331.047L464.636 319.821L438.366 312.784Z",
    fill: "url(#paint300_linear_0_196)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 312.784L512.275 265.275L464.636 319.821L438.366 312.784Z",
    fill: "url(#paint301_linear_0_196)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 331.047L461.514 328.75L464.636 319.821L456.241 331.047Z",
    fill: "url(#paint302_linear_0_196)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M461.514 328.75L482.381 333.652L464.636 319.821L461.514 328.75Z",
    fill: "url(#paint303_linear_0_196)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 333.652L499.01 323.784L464.636 319.821L482.381 333.652Z",
    fill: "url(#paint304_linear_0_196)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M499.01 323.784L514.992 295.12L464.636 319.821L499.01 323.784Z",
    fill: "url(#paint305_linear_0_196)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M512.275 265.275L514.992 295.12L464.636 319.821L512.275 265.275Z",
    fill: "url(#paint306_linear_0_196)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 344.198L484.193 339.249L497.377 340.413L481.492 344.198Z",
    fill: "url(#paint307_linear_0_196)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 344.198L511.66 379.656L497.377 340.413L481.492 344.198Z",
    fill: "url(#paint308_linear_0_196)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M482.382 333.652L484.193 339.249L497.377 340.413L482.382 333.652Z",
    fill: "url(#paint309_linear_0_196)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M482.382 333.652L499.011 323.784L497.377 340.413L482.382 333.652Z",
    fill: "url(#paint310_linear_0_196)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M499.011 323.784L514.992 295.12L497.377 340.413L499.011 323.784Z",
    fill: "url(#paint311_linear_0_196)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M511.66 379.656L514.992 295.12L497.377 340.413L511.66 379.656Z",
    fill: "url(#paint312_linear_0_196)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M395.16 608.904L415.558 581.825L354.995 578.218L395.16 608.904Z",
    fill: "url(#paint313_linear_0_196)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 543.698L363.989 534.316L354.995 578.218L347.052 543.698Z",
    fill: "url(#paint314_linear_0_196)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M305.285 606.834L288.495 521.019L308.666 581.971L305.285 606.834Z",
    fill: "url(#paint315_linear_0_196)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M305.285 606.834L395.16 608.904L308.666 581.971L305.285 606.834Z",
    fill: "url(#paint316_linear_0_196)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 521.019L315.444 529.819L308.666 581.971L288.495 521.019Z",
    fill: "url(#paint317_linear_0_196)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 529.819L327.236 535.821L308.666 581.971L315.444 529.819Z",
    fill: "url(#paint318_linear_0_196)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 535.821L347.052 543.698L308.666 581.971L327.236 535.821Z",
    fill: "url(#paint319_linear_0_196)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M395.16 608.904L354.995 578.218L308.666 581.971L395.16 608.904Z",
    fill: "url(#paint320_linear_0_196)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 543.698L354.995 578.218L308.666 581.971L347.052 543.698Z",
    fill: "url(#paint321_linear_0_196)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 352.675L208.763 494.863L209.733 425.596L171.46 352.675Z",
    fill: "url(#paint322_linear_0_196)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M208.763 494.863L271.17 514.743L209.733 425.597L208.763 494.863Z",
    fill: "url(#paint323_linear_0_196)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 364.871L276.46 368.01L209.733 425.596L253.409 364.871Z",
    fill: "url(#paint324_linear_0_196)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 514.743L298.961 451.786L209.733 425.597L271.17 514.743Z",
    fill: "url(#paint325_linear_0_196)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 368.01L298.961 451.786L209.733 425.596L276.46 368.01Z",
    fill: "url(#paint326_linear_0_196)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 521.521L389.854 519.418L401.938 522.766L386.91 521.521Z",
    fill: "url(#paint327_linear_0_196)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 519.418L394.739 518.447L401.938 522.766L389.854 519.418Z",
    fill: "url(#paint328_linear_0_196)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M394.739 518.447L401.064 516.053L401.938 522.766L394.739 518.447Z",
    fill: "url(#paint329_linear_0_196)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M401.064 516.053L406.564 513.19L401.938 522.766L401.064 516.053Z",
    fill: "url(#paint330_linear_0_196)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 513.19L410.64 512.042L401.938 522.766L406.564 513.19Z",
    fill: "url(#paint331_linear_0_196)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M410.64 512.042L424.487 511.831L401.938 522.766L410.64 512.042Z",
    fill: "url(#paint332_linear_0_196)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 511.831L415.558 581.825L401.938 522.766L424.487 511.831Z",
    fill: "url(#paint333_linear_0_196)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M354.995 578.218L415.558 581.825L382.672 532.618L354.995 578.218Z",
    fill: "url(#paint334_linear_0_196)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 521.521L401.938 522.766L382.672 532.618L386.91 521.521Z",
    fill: "url(#paint335_linear_0_196)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M401.938 522.766L415.558 581.825L382.672 532.618L401.938 522.766Z",
    fill: "url(#paint336_linear_0_196)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 534.316L354.995 578.218L382.672 532.618L363.989 534.316Z",
    fill: "url(#paint337_linear_0_196)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 534.316L365.865 528.913L382.672 532.618L363.989 534.316Z",
    fill: "url(#paint338_linear_0_196)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M365.865 528.913L370.152 524.335L382.672 532.618L365.865 528.913Z",
    fill: "url(#paint339_linear_0_196)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 524.335L386.91 521.521L382.672 532.618L370.152 524.335Z",
    fill: "url(#paint340_linear_0_196)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M372.303 501.915L373.371 504.957L382.267 499.182L372.303 501.915Z",
    fill: "url(#paint341_linear_0_196)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 504.957L385.017 503.63L382.267 499.182L373.371 504.957Z",
    fill: "url(#paint342_linear_0_196)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M385.018 503.63L398.153 507.156L382.268 499.182L385.018 503.63Z",
    fill: "url(#paint343_linear_0_196)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 461.653L398.153 507.156L382.268 499.182L392.2 461.653Z",
    fill: "url(#paint344_linear_0_196)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 495.866L392.2 461.653L382.268 499.182L361.028 495.866Z",
    fill: "url(#paint345_linear_0_196)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 495.865L365.461 498.599L382.268 499.182L361.028 495.865Z",
    fill: "url(#paint346_linear_0_196)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M365.461 498.599L372.303 501.915L382.268 499.182L365.461 498.599Z",
    fill: "url(#paint347_linear_0_196)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 529.819L327.236 535.821L327.641 531.599L315.444 529.819Z",
    fill: "url(#paint348_linear_0_196)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 529.819L327.172 523.527L327.641 531.599L315.444 529.819Z",
    fill: "url(#paint349_linear_0_196)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 535.82L340.824 529.884L327.641 531.598L327.236 535.82Z",
    fill: "url(#paint350_linear_0_196)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 523.527L340.825 529.884L327.641 531.599L327.172 523.527Z",
    fill: "url(#paint351_linear_0_196)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 336.013L221.073 328.556L223.806 338.521L208.148 336.013Z",
    fill: "url(#paint352_linear_0_196)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M221.073 328.556L237.443 338.844L223.806 338.521L221.073 328.556Z",
    fill: "url(#paint353_linear_0_196)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 342.484L237.443 338.844L223.806 338.521L232.024 342.484Z",
    fill: "url(#paint354_linear_0_196)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 352.675L198.038 336.919L227.025 347.903L171.46 352.675Z",
    fill: "url(#paint355_linear_0_196)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 352.675L209.733 425.597L227.025 347.903L171.46 352.675Z",
    fill: "url(#paint356_linear_0_196)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 336.919L208.148 336.013L227.025 347.903L198.038 336.919Z",
    fill: "url(#paint357_linear_0_196)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M209.733 425.597L253.409 364.872L227.025 347.903L209.733 425.597Z",
    fill: "url(#paint358_linear_0_196)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 336.013L223.806 338.52L227.025 347.903L208.148 336.013Z",
    fill: "url(#paint359_linear_0_196)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M223.806 338.521L232.024 342.484L227.025 347.903L223.806 338.521Z",
    fill: "url(#paint360_linear_0_196)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 342.484L239.966 343.584L227.025 347.903L232.024 342.484Z",
    fill: "url(#paint361_linear_0_196)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M239.966 343.584L253.409 364.872L227.025 347.903L239.966 343.584Z",
    fill: "url(#paint362_linear_0_196)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.88,
    d: "M512.275 265.275L499.916 206.75L445.063 132.712L316.706 119.237L245.579 136.934L172.205 230.949L171.46 352.675L208.763 494.863L305.285 606.834L395.16 608.904L415.558 581.825L469.893 505.167L511.66 379.656L514.992 295.12L512.275 265.275Z",
    fill: "url(#paint363_radial_0_196)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L396.147 348.226L344.626 374.335L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L423.403 210.228L337.072 166.779L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L354.93 303.289L337.071 166.779L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L337.071 166.779L234.337 153.32L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 153.32L272.933 238.52L189.254 233.279L234.337 153.32Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 166.779L423.403 210.228L430.359 142.628L337.072 166.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L438.366 305.926L490.777 217.459L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L511.66 372.798L445.257 451.3L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 451.3L448.784 351.559L394.48 407.754L445.257 451.3Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.335L396.147 348.226L394.481 407.754L344.626 374.335Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 442.29L392.2 454.794L352.811 456.008L374.325 442.29Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L374.325 442.29L352.811 456.008L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L392.2 454.794L352.811 456.008L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L352.811 456.008L326.055 455.296L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L352.811 456.008L326.055 455.296L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L271.17 507.885L231.069 509.632L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L189.254 233.279L171.46 345.816L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L189.254 233.279L172.205 224.091L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L234.337 153.32L172.205 224.091L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M172.205 224.091L234.337 153.32L245.579 130.075L172.205 224.091Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 153.32L337.071 166.779L245.579 130.075L234.337 153.32Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M245.579 130.075L337.071 166.779L316.706 112.379L245.579 130.075Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 166.779L430.359 142.628L316.706 112.379L337.072 166.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M316.706 112.379L430.359 142.628L445.063 125.853L316.706 112.379Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L490.777 217.459L512.275 258.417L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L430.359 142.628L499.916 199.891L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L490.777 217.459L499.916 199.891L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M430.359 142.628L445.063 125.853L499.916 199.891L430.359 142.628Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M490.777 217.459L512.275 258.417L499.916 199.891L490.777 217.459Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L415.267 577.555L469.893 498.308L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L445.257 451.301L469.893 498.308L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 451.3L511.66 372.798L469.894 498.308L445.257 451.3Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L355.075 527.231L363.988 527.457L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L348.783 512.624L353.409 508.806L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 512.624L359.071 516.393L353.409 508.806L348.783 512.624Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L298.799 503.808L298.604 513.239L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L271.17 507.885L288.495 514.161L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L282.412 510.521L288.495 514.161L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 504.633L298.605 513.239L288.495 514.161L295.467 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L315.444 522.961L288.495 514.161L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.961L327.56 509.308L327.172 516.668L315.444 522.961Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L347.052 536.84L340.824 523.025L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L348.783 512.624L340.824 523.025L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L355.075 527.231L340.824 523.025L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L348.783 512.624L350.174 519.305L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L355.075 527.231L350.174 519.305L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 512.624L359.071 516.393L350.174 519.305L348.783 512.624Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L359.071 516.393L350.174 519.305L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L391.504 507.707L389.854 512.559L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.707L391.811 511.071L389.854 512.559L391.504 507.707Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L327.56 509.308L328.498 513.934L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L340.824 523.025L328.498 513.934L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 509.308L338.543 503.614L328.498 513.934L327.56 509.308Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L342.814 507.399L328.498 513.934L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L342.814 507.399L328.498 513.934L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615L384.387 509.923L373.371 498.098V509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L342.814 507.399L341.973 503.824L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 509.308L338.543 503.614L324.729 501.204L327.56 509.308Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L298.799 503.808L305.091 501.139L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L315.444 522.961L305.091 501.139L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L298.799 503.808L299.51 502.967L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M298.799 503.808L305.091 501.139L299.51 502.967L298.799 503.808Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L315.444 522.961L312.84 499.926L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.961L327.56 509.308L312.84 499.926L315.444 522.961Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L327.56 509.308L312.84 499.926L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L325.392 496.949L337.298 498.486L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L338.543 503.614L337.298 498.486L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L341.973 503.824L337.298 498.486L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L341.973 503.824L344.658 498.874L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M341.973 503.824L342.814 507.399L344.658 498.875L341.973 503.824Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L353.409 508.807L344.658 498.875L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 498.874L353.409 508.807L357.68 498.211L344.658 498.874Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615V498.098L358.877 505.684L373.371 509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 508.807L359.071 516.393L358.877 505.685L353.409 508.807Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 508.807L357.68 498.211L358.877 505.685L353.409 508.807Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 516.393L370.151 517.493L358.877 505.685L359.071 516.393Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 498.211L359.33 496.221L358.877 505.684L357.68 498.211Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L373.371 498.098L358.877 505.684L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M370.151 517.493L373.371 509.615L358.877 505.685L370.151 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L344.658 498.874L346.34 491.385L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 498.874L357.68 498.211L346.34 491.385L344.658 498.874Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 498.211L359.33 496.221L346.34 491.385L357.68 498.211Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 496.949L337.298 498.486L337.557 486.953L325.392 496.949Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M326.055 455.296L350.255 465.39L337.557 486.953L326.055 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L346.34 491.385L337.557 486.953L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L350.255 465.39L337.557 486.953L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L312.84 499.926L313.907 494.329L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M312.84 499.926L324.729 501.204L313.907 494.329L312.84 499.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L325.392 496.949L313.907 494.329L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 496.949L337.557 486.953L313.907 494.329L325.392 496.949Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M326.055 455.296L337.557 486.953L313.907 494.329L326.055 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M282.412 510.521L288.495 514.161L292.668 502.53L282.412 510.521Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 514.161L295.467 504.633L292.668 502.53L288.495 514.161Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L299.51 502.967L292.668 502.53L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M299.51 502.967L305.091 501.139L292.668 502.53L299.51 502.967Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L313.907 494.329L292.668 502.53L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L282.412 510.521L280.73 503.614L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M282.412 510.521L292.668 502.53L280.73 503.614L282.412 510.521Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L350.255 465.39L361.028 489.007L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L359.33 496.221L361.028 489.007L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L392.2 454.794L361.028 489.007L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L373.371 498.098L365.461 491.741L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L361.028 489.007L365.461 491.741L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M365.46 491.741L373.371 498.098L372.303 495.057L365.46 491.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 498.098L384.387 509.923L385.017 496.788L373.371 498.098Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L391.504 507.706L385.017 496.788L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M385.017 496.788L391.504 507.706L398.152 500.298L385.017 496.788Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L398.152 500.298L406.418 501.899L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 500.298L401.776 502.579L406.418 501.899L398.152 500.298Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 502.579L406.564 506.332L406.418 501.899L401.776 502.579Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 506.332L406.418 501.899L410.64 505.183L406.564 506.332Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 501.899L424.487 504.973L410.64 505.183L406.418 501.899Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.706L398.153 500.298L401.064 509.195L391.504 507.706Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 500.298L401.776 502.579L401.064 509.195L398.152 500.298Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 502.579L406.564 506.331L401.064 509.195L401.776 502.579Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 512.559L391.811 511.071L394.739 511.589L389.854 512.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M391.812 511.071L391.504 507.707L394.739 511.589L391.812 511.071Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.707L401.064 509.195L394.739 511.589L391.504 507.707Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615L384.387 509.923L386.91 514.662L373.371 509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L389.854 512.559L386.91 514.662L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 517.493L373.371 509.615L386.91 514.662L370.152 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L359.071 516.393L365.865 522.055L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L363.988 527.458L365.865 522.055L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 516.393L370.151 517.493L365.865 522.055L359.071 516.393Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L256.288 332.115L262.354 318.22L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 313.723L271.704 314.499L264.586 316.715L268.76 313.723Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L272.933 238.52L256.579 306.443L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 318.22L264.586 316.715L256.579 306.443L262.354 318.22Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M264.586 316.715L268.76 313.723L256.579 306.443L264.586 316.715Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L256.579 306.443L238.543 315.146L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L244.479 331.614L238.543 315.146L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L248.798 330.174L238.543 315.146L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L262.354 318.22L238.543 315.146L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L262.354 318.22L238.543 315.146L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L189.254 233.279L221.073 321.697L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L238.543 315.146L221.073 321.697L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L238.543 315.146L221.073 321.698L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L221.073 321.698L208.148 329.155L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L248.799 330.174L255.075 335.884L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L256.288 332.115L255.075 335.884L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L264.117 337.68L255.075 335.884L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L262.354 318.22L270.944 329.219L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L264.117 337.679L270.944 329.219L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 318.22L264.586 316.715L270.944 329.219L262.354 318.22Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M264.586 316.715L271.704 314.499L270.944 329.219L264.586 316.715Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L300.707 337.243L270.943 329.219L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L268.76 313.723L278.805 312.024L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L272.933 238.52L278.805 312.024L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 313.723L271.704 314.499L278.805 312.024L268.76 313.723Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L271.704 314.499L278.805 312.024L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L294.059 324.512L278.805 312.024L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 312.024L272.933 238.52L286.796 310.779L278.805 312.024Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 312.024L294.059 324.512L286.796 310.779L278.805 312.024Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L354.93 303.289L302.794 316.909L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L286.796 310.779L302.794 316.909L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M286.796 310.779L294.059 324.512L302.794 316.909L286.796 310.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L354.93 303.289L302.794 316.909L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L300.707 337.243L309.038 325.24L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L302.794 316.909L309.038 325.24L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M302.794 316.909L320.572 328.378L309.038 325.24L302.794 316.909Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L309.038 325.24L310.219 326.696L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M309.038 325.24L320.572 328.378L310.219 326.696L309.038 325.24Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L307.097 352.885L317.579 332.843L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L310.219 326.696L317.579 332.843L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M310.219 326.696L320.572 328.378L317.579 332.843L310.219 326.696Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L317.579 332.843L326.589 334.121L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M317.579 332.843L320.572 328.378L326.589 334.121L317.579 332.843Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L381.572 323.121L332.008 336.24L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L326.589 334.121L332.008 336.24L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L344.625 374.334L332.008 336.24L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L354.93 303.289L332.008 336.24L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L326.589 334.121L332.008 336.24L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.335L381.572 323.121L332.008 336.24L344.626 374.335Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L307.097 352.885L302.39 349.909L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M302.39 349.909L307.097 352.885L276.459 361.167L302.39 349.909Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M253.408 358.013L255.075 335.884L268.533 345.913L253.408 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M253.408 358.013L276.459 361.167L268.533 345.913L253.408 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M255.075 335.884L264.117 337.68L268.533 345.913L255.075 335.884Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M264.117 337.679L270.944 329.219L268.533 345.913L264.117 337.679Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L300.707 337.243L268.533 345.913L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L302.39 349.909L268.533 345.913L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M300.707 337.243L302.39 349.909L268.533 345.913L300.707 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L244.479 331.614L239.966 336.741L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L255.075 335.884L239.966 336.741L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 358.013L255.075 335.884L239.966 336.741L253.409 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L239.966 336.741L232.024 335.625L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L381.572 323.121L401.533 315.292L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L423.403 210.228L401.533 315.292L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L396.147 348.226L390.679 322.555L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L401.533 315.292L390.679 322.555L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L444.756 330.206L447.975 339.863L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L433.077 337.016L423.419 337.372L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 322.555L396.146 348.226L394.594 322.458L390.679 322.555Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 322.555L401.533 315.292L394.594 322.458L390.679 322.555Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L404.154 321.067L394.594 322.458L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L404.154 321.067L422.319 307.916L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L423.403 210.228L422.319 307.916L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 321.067L420.023 334.541L422.32 307.916L404.154 321.067Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L438.366 305.926L422.319 307.916L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L422.319 307.916L436.215 311.102L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L433.077 337.016L436.215 311.102L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M422.319 307.915L438.366 305.926L436.215 311.102L422.319 307.915Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L444.756 330.206L436.215 311.102L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L456.241 324.205L436.215 311.102L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L456.241 324.205L436.215 311.102L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.708 326.841L461.514 321.892L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 326.841L461.514 321.892L482.381 326.793L461.708 326.841Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L447.975 339.863L453.07 335.479L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L456.241 324.205L453.07 335.48L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L447.975 339.863L453.07 335.479L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.708 326.842L453.07 335.48L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L447.975 339.863L433.158 340.947L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L447.975 339.863L433.157 340.947L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M396.147 348.226L394.594 322.458L409.718 333.377L396.147 348.226Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M394.594 322.458L404.154 321.067L409.718 333.377L394.594 322.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 321.067L420.023 334.541L409.718 333.377L404.154 321.067Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L396.147 348.226L424.697 339.879L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L448.784 351.559L424.697 339.879L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M396.146 348.226L409.718 333.377L424.697 339.879L396.146 348.226Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M409.719 333.377L420.023 334.541L424.698 339.879L409.719 333.377Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L423.419 337.372L424.697 339.879L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M423.419 337.372L433.077 337.016L424.697 339.88L423.419 337.372Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M433.157 340.947L433.077 337.016L424.697 339.88L433.157 340.947Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M433.157 340.947L448.783 351.559L424.697 339.879L433.157 340.947Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L307.097 352.885L316.884 432.051L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L326.056 455.296L316.884 432.051L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L344.625 374.335L316.883 432.051L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 455.296L339.627 437.583L316.884 432.051L326.056 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.884L280.73 503.614L298.96 444.927L271.17 507.884Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M280.73 503.614L292.668 502.53L298.96 444.927L280.73 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L316.884 432.051L298.96 444.927L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L316.884 432.051L298.96 444.927L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 432.051L339.627 437.583L356.305 419.595L316.884 432.051Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 432.051L344.626 374.334L356.305 419.595L316.884 432.051Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L374.325 442.29L356.305 419.595L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.334L394.481 407.754L356.305 419.595L344.626 374.334Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 442.29L392.2 454.795L381.459 428.557L374.325 442.29Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 419.595L374.325 442.29L381.459 428.557L356.305 419.595Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 419.595L394.481 407.754L381.459 428.557L356.305 419.595Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L406.418 501.899L404.898 444.749L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 501.899L424.487 504.973L404.898 444.749L406.418 501.899Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L445.257 451.3L404.898 444.749L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 502.53L298.96 444.927L305.382 449.311L292.668 502.53Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 502.53L313.907 494.329L305.382 449.311L292.668 502.53Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M298.96 444.927L307.663 448.583L305.382 449.311L298.96 444.927Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L326.055 455.296L305.382 449.311L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M313.907 494.329L326.055 455.296L305.382 449.311L313.907 494.329Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 428.557L392.2 454.795L404.332 438.521L381.459 428.557Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 428.557L394.481 407.754L404.332 438.521L381.459 428.557Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L404.898 444.749L404.332 438.521L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L445.257 451.3L404.332 438.521L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M404.898 444.749L445.257 451.3L404.332 438.521L404.898 444.749Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L453.07 335.479L481.492 337.34L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L511.66 372.798L481.492 337.34L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M453.07 335.48L461.708 326.842L481.492 337.34L453.07 335.48Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 326.841L482.381 326.793L481.492 337.34L461.708 326.841Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L484.193 332.39L481.492 337.34L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L456.241 324.205L464.636 312.962L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L512.275 258.417L464.636 312.962L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.514 321.892L464.636 312.962L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M461.514 321.892L482.381 326.793L464.636 312.962L461.514 321.892Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L499.01 316.926L464.636 312.962L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M499.01 316.926L514.992 288.261L464.636 312.962L499.01 316.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M512.275 258.417L514.992 288.261L464.636 312.962L512.275 258.417Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 337.34L484.193 332.39L497.377 333.555L481.492 337.34Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 337.34L511.66 372.798L497.377 333.555L481.492 337.34Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L484.193 332.39L497.377 333.555L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L499.01 316.926L497.377 333.555L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M499.011 316.926L514.992 288.261L497.377 333.555L499.011 316.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M511.66 372.798L514.992 288.261L497.377 333.555L511.66 372.798Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M369.731 605.523L415.267 577.555L354.995 571.359L369.731 605.523Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L363.988 527.458L354.994 571.359L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L288.495 514.161L308.666 575.129L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L369.731 605.523L308.666 575.128L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 514.161L315.444 522.961L308.666 575.129L288.495 514.161Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.236 528.962L308.666 575.128L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L347.052 536.84L308.666 575.128L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M369.731 605.523L354.995 571.359L308.666 575.128L369.731 605.523Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L354.995 571.36L308.666 575.129L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L231.069 509.632L209.733 418.738L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M231.069 509.632L271.17 507.885L209.733 418.738L231.069 509.632Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 358.013L276.46 361.167L209.733 418.738L253.409 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L298.961 444.927L209.733 418.738L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 361.167L298.961 444.927L209.733 418.738L276.46 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 514.662L389.854 512.559L401.938 515.908L386.91 514.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 512.559L394.739 511.589L401.938 515.908L389.854 512.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M394.739 511.589L401.064 509.195L401.938 515.908L394.739 511.589Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M401.064 509.195L406.564 506.332L401.938 515.908L401.064 509.195Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 506.332L410.64 505.183L401.938 515.908L406.564 506.332Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M410.64 505.183L424.487 504.973L401.938 515.908L410.64 505.183Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L415.267 577.555L401.938 515.908L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M354.995 571.36L415.267 577.555L382.672 525.775L354.995 571.36Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 514.662L401.938 515.908L382.672 525.775L386.91 514.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M401.938 515.908L415.267 577.555L382.672 525.775L401.938 515.908Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 527.458L354.995 571.36L382.672 525.775L363.989 527.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 527.458L365.865 522.055L382.672 525.775L363.989 527.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M365.865 522.055L370.152 517.493L382.672 525.775L365.865 522.055Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 517.493L386.91 514.662L382.672 525.775L370.152 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M372.303 495.057L373.371 498.098L382.267 492.323L372.303 495.057Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 498.098L385.017 496.788L382.267 492.323L373.371 498.098Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M385.018 496.788L398.153 500.298L382.268 492.323L385.018 496.788Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 454.794L398.153 500.298L382.268 492.323L392.2 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 489.007L392.2 454.794L382.268 492.323L361.028 489.007Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 489.007L365.461 491.741L382.268 492.323L361.028 489.007Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M365.46 491.741L372.303 495.057L382.267 492.323L365.46 491.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.236 528.962L327.641 524.74L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.172 516.668L327.641 524.74L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L340.824 523.025L327.641 524.74L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L340.824 523.025L327.641 524.74L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 329.155L221.073 321.698L223.806 331.662L208.148 329.155Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M221.073 321.698L237.443 331.986L223.806 331.662L221.073 321.698Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 335.625L237.443 331.985L223.806 331.662L232.024 335.625Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L198.038 330.077L227.025 341.044L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L209.733 418.738L227.025 341.044L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L208.148 329.155L227.025 341.044L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M209.733 418.738L253.409 358.013L227.025 341.044L209.733 418.738Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 329.155L223.806 331.662L227.025 341.044L208.148 329.155Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M223.806 331.662L232.024 335.625L227.025 341.044L223.806 331.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 335.625L239.966 336.741L227.025 341.044L232.024 335.625Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M239.966 336.741L253.409 358.013L227.025 341.044L239.966 336.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L396.147 348.226L344.626 374.335L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L423.403 210.228L337.072 166.779L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L354.93 303.289L337.071 166.779L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L337.071 166.779L234.337 153.32L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 153.32L272.933 238.52L189.254 233.279L234.337 153.32Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 166.779L423.403 210.228L430.359 142.628L337.072 166.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L438.366 305.926L490.777 217.459L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L511.66 372.798L445.257 451.3L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 451.3L448.784 351.559L394.48 407.754L445.257 451.3Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.335L396.147 348.226L394.481 407.754L344.626 374.335Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 442.29L392.2 454.794L352.811 456.008L374.325 442.29Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L374.325 442.29L352.811 456.008L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L392.2 454.794L352.811 456.008L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L352.811 456.008L326.055 455.296L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L352.811 456.008L326.055 455.296L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L271.17 507.885L231.069 509.632L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L189.254 233.279L171.46 345.816L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L189.254 233.279L172.205 224.091L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L234.337 153.32L172.205 224.091L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M172.205 224.091L234.337 153.32L245.579 130.075L172.205 224.091Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M234.337 153.32L337.071 166.779L245.579 130.075L234.337 153.32Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M245.579 130.075L337.071 166.779L316.706 112.379L245.579 130.075Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M337.072 166.779L430.359 142.628L316.706 112.379L337.072 166.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M316.706 112.379L430.359 142.628L445.063 125.853L316.706 112.379Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L490.777 217.459L512.275 258.417L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L430.359 142.628L499.916 199.891L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L490.777 217.459L499.916 199.891L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M430.359 142.628L445.063 125.853L499.916 199.891L430.359 142.628Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M490.777 217.459L512.275 258.417L499.916 199.891L490.777 217.459Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L415.267 577.555L469.893 498.308L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L445.257 451.301L469.893 498.308L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M445.257 451.3L511.66 372.798L469.894 498.308L445.257 451.3Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L355.075 527.231L363.988 527.457L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L348.783 512.624L353.409 508.806L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 512.624L359.071 516.393L353.409 508.806L348.783 512.624Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L298.799 503.808L298.604 513.239L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L271.17 507.885L288.495 514.161L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L282.412 510.521L288.495 514.161L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M295.467 504.633L298.605 513.239L288.495 514.161L295.467 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L315.444 522.961L288.495 514.161L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.961L327.56 509.308L327.172 516.668L315.444 522.961Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L347.052 536.84L340.824 523.025L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L348.783 512.624L340.824 523.025L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L355.075 527.231L340.824 523.025L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L348.783 512.624L350.174 519.305L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L355.075 527.231L350.174 519.305L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M348.783 512.624L359.071 516.393L350.174 519.305L348.783 512.624Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L359.071 516.393L350.174 519.305L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L391.504 507.707L389.854 512.559L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.707L391.811 511.071L389.854 512.559L391.504 507.707Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L327.56 509.308L328.498 513.934L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L340.824 523.025L328.498 513.934L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 509.308L338.543 503.614L328.498 513.934L327.56 509.308Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L342.814 507.399L328.498 513.934L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M340.824 523.025L342.814 507.399L328.498 513.934L340.824 523.025Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615L384.387 509.923L373.371 498.098V509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L342.814 507.399L341.973 503.824L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M327.56 509.308L338.543 503.614L324.729 501.204L327.56 509.308Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L298.799 503.808L305.091 501.139L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 513.239L315.444 522.961L305.091 501.139L298.605 513.239Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L298.799 503.808L299.51 502.967L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M298.799 503.808L305.091 501.139L299.51 502.967L298.799 503.808Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L315.444 522.961L312.84 499.926L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.961L327.56 509.308L312.84 499.926L315.444 522.961Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L327.56 509.308L312.84 499.926L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L325.392 496.949L337.298 498.486L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L338.543 503.614L337.298 498.486L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M338.543 503.614L341.973 503.824L337.298 498.486L338.543 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L341.973 503.824L344.658 498.874L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M341.973 503.824L342.814 507.399L344.658 498.875L341.973 503.824Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M342.814 507.399L353.409 508.807L344.658 498.875L342.814 507.399Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 498.874L353.409 508.807L357.68 498.211L344.658 498.874Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615V498.098L358.877 505.684L373.371 509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 508.807L359.071 516.393L358.877 505.685L353.409 508.807Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M353.409 508.807L357.68 498.211L358.877 505.685L353.409 508.807Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 516.393L370.151 517.493L358.877 505.685L359.071 516.393Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 498.211L359.33 496.221L358.877 505.684L357.68 498.211Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L373.371 498.098L358.877 505.684L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M370.151 517.493L373.371 509.615L358.877 505.685L370.151 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L344.658 498.874L346.34 491.385L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M344.658 498.874L357.68 498.211L346.34 491.385L344.658 498.874Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M357.68 498.211L359.33 496.221L346.34 491.385L357.68 498.211Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 496.949L337.298 498.486L337.557 486.953L325.392 496.949Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M326.055 455.296L350.255 465.39L337.557 486.953L326.055 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 498.486L346.34 491.385L337.557 486.953L337.298 498.486Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L350.255 465.39L337.557 486.953L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L312.84 499.926L313.907 494.329L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M312.84 499.926L324.729 501.204L313.907 494.329L312.84 499.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M324.729 501.204L325.392 496.949L313.907 494.329L324.729 501.204Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M325.392 496.949L337.557 486.953L313.907 494.329L325.392 496.949Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M326.055 455.296L337.557 486.953L313.907 494.329L326.055 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M282.412 510.521L288.495 514.161L292.668 502.53L282.412 510.521Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 514.161L295.467 504.633L292.668 502.53L288.495 514.161Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M295.466 504.633L299.51 502.967L292.668 502.53L295.466 504.633Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M299.51 502.967L305.091 501.139L292.668 502.53L299.51 502.967Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M305.091 501.139L313.907 494.329L292.668 502.53L305.091 501.139Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L282.412 510.521L280.73 503.614L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M282.412 510.521L292.668 502.53L280.73 503.614L282.412 510.521Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L350.255 465.39L361.028 489.007L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M346.34 491.385L359.33 496.221L361.028 489.007L346.34 491.385Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M350.255 465.39L392.2 454.794L361.028 489.007L350.255 465.39Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L373.371 498.098L365.461 491.741L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33 496.221L361.028 489.007L365.461 491.741L359.33 496.221Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M365.46 491.741L373.371 498.098L372.303 495.057L365.46 491.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 498.098L384.387 509.923L385.017 496.788L373.371 498.098Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L391.504 507.706L385.017 496.788L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M385.017 496.788L391.504 507.706L398.152 500.298L385.017 496.788Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L398.152 500.298L406.418 501.899L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 500.298L401.776 502.579L406.418 501.899L398.152 500.298Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 502.579L406.564 506.332L406.418 501.899L401.776 502.579Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 506.332L406.418 501.899L410.64 505.183L406.564 506.332Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 501.899L424.487 504.973L410.64 505.183L406.418 501.899Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.706L398.153 500.298L401.064 509.195L391.504 507.706Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M398.152 500.298L401.776 502.579L401.064 509.195L398.152 500.298Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M401.776 502.579L406.564 506.331L401.064 509.195L401.776 502.579Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 512.559L391.811 511.071L394.739 511.589L389.854 512.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M391.812 511.071L391.504 507.707L394.739 511.589L391.812 511.071Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 507.707L401.064 509.195L394.739 511.589L391.504 507.707Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 509.615L384.387 509.923L386.91 514.662L373.371 509.615Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 509.923L389.854 512.559L386.91 514.662L384.386 509.923Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 517.493L373.371 509.615L386.91 514.662L370.152 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L359.071 516.393L365.865 522.055L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M355.075 527.231L363.988 527.458L365.865 522.055L355.075 527.231Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M359.071 516.393L370.151 517.493L365.865 522.055L359.071 516.393Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L256.288 332.115L262.354 318.22L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 313.723L271.704 314.499L264.586 316.715L268.76 313.723Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L272.933 238.52L256.579 306.443L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 318.22L264.586 316.715L256.579 306.443L262.354 318.22Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M264.586 316.715L268.76 313.723L256.579 306.443L264.586 316.715Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L256.579 306.443L238.543 315.146L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L244.479 331.614L238.543 315.146L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L248.798 330.174L238.543 315.146L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L262.354 318.22L238.543 315.146L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L262.354 318.22L238.543 315.146L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L189.254 233.279L221.073 321.697L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M189.254 233.279L238.543 315.146L221.073 321.697L189.254 233.279Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L238.543 315.146L221.073 321.698L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L221.073 321.698L208.148 329.155L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L248.799 330.174L255.075 335.884L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 330.174L256.288 332.115L255.075 335.884L248.798 330.174Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L264.117 337.68L255.075 335.884L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L262.354 318.22L270.944 329.219L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M256.288 332.115L264.117 337.679L270.944 329.219L256.288 332.115Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M262.354 318.22L264.586 316.715L270.944 329.219L262.354 318.22Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M264.586 316.715L271.704 314.499L270.944 329.219L264.586 316.715Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L300.707 337.243L270.943 329.219L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L268.76 313.723L278.805 312.024L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M256.579 306.443L272.933 238.52L278.805 312.024L256.579 306.443Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M268.76 313.723L271.704 314.499L278.805 312.024L268.76 313.723Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L271.704 314.499L278.805 312.024L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L294.059 324.512L278.805 312.024L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 312.024L272.933 238.52L286.796 310.779L278.805 312.024Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M278.805 312.024L294.059 324.512L286.796 310.779L278.805 312.024Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L354.93 303.289L302.794 316.909L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M272.933 238.52L286.796 310.779L302.794 316.909L272.933 238.52Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M286.796 310.779L294.059 324.512L302.794 316.909L286.796 310.779Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L354.93 303.289L302.794 316.909L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L300.707 337.243L309.038 325.24L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 324.512L302.794 316.909L309.038 325.24L294.059 324.512Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M302.794 316.909L320.572 328.378L309.038 325.24L302.794 316.909Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L309.038 325.24L310.219 326.696L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M309.038 325.24L320.572 328.378L310.219 326.696L309.038 325.24Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L307.097 352.885L317.579 332.843L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L310.219 326.696L317.579 332.843L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M310.219 326.696L320.572 328.378L317.579 332.843L310.219 326.696Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L317.579 332.843L326.589 334.121L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M317.579 332.843L320.572 328.378L326.589 334.121L317.579 332.843Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L381.572 323.121L332.008 336.24L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L326.589 334.121L332.008 336.24L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L344.625 374.334L332.008 336.24L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L354.93 303.289L332.008 336.24L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 328.378L326.589 334.121L332.008 336.24L320.572 328.378Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.335L381.572 323.121L332.008 336.24L344.626 374.335Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M300.708 337.243L307.097 352.885L302.39 349.909L300.708 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M302.39 349.909L307.097 352.885L276.459 361.167L302.39 349.909Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M253.408 358.013L255.075 335.884L268.533 345.913L253.408 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M253.408 358.013L276.459 361.167L268.533 345.913L253.408 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M255.075 335.884L264.117 337.68L268.533 345.913L255.075 335.884Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M264.117 337.679L270.944 329.219L268.533 345.913L264.117 337.679Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M270.943 329.219L300.707 337.243L268.533 345.913L270.943 329.219Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L302.39 349.909L268.533 345.913L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M300.707 337.243L302.39 349.909L268.533 345.913L300.707 337.243Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L244.479 331.614L239.966 336.741L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 331.614L255.075 335.884L239.966 336.741L244.479 331.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 358.013L255.075 335.884L239.966 336.741L253.409 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M237.443 331.986L239.966 336.741L232.024 335.625L237.443 331.986Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L381.572 323.121L401.533 315.292L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93 303.289L423.403 210.228L401.533 315.292L354.93 303.289Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L396.147 348.226L390.679 322.555L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M381.572 323.121L401.533 315.292L390.679 322.555L381.572 323.121Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L444.756 330.206L447.975 339.863L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L433.077 337.016L423.419 337.372L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 322.555L396.146 348.226L394.594 322.458L390.679 322.555Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M390.679 322.555L401.533 315.292L394.594 322.458L390.679 322.555Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L404.154 321.067L394.594 322.458L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L404.154 321.067L422.319 307.916L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M401.533 315.292L423.403 210.228L422.319 307.916L401.533 315.292Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 321.067L420.023 334.541L422.32 307.916L404.154 321.067Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M423.403 210.228L438.366 305.926L422.319 307.916L423.403 210.228Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L422.319 307.916L436.215 311.102L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L433.077 337.016L436.215 311.102L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M422.319 307.915L438.366 305.926L436.215 311.102L422.319 307.915Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L444.756 330.206L436.215 311.102L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L456.241 324.205L436.215 311.102L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L456.241 324.205L436.215 311.102L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.708 326.841L461.514 321.892L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 326.841L461.514 321.892L482.381 326.793L461.708 326.841Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L447.975 339.863L453.07 335.479L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M444.756 330.206L456.241 324.205L453.07 335.48L444.756 330.206Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L447.975 339.863L453.07 335.479L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.708 326.842L453.07 335.48L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M433.077 337.016L447.975 339.863L433.158 340.947L433.077 337.016Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L447.975 339.863L433.157 340.947L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M396.147 348.226L394.594 322.458L409.718 333.377L396.147 348.226Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M394.594 322.458L404.154 321.067L409.718 333.377L394.594 322.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M404.154 321.067L420.023 334.541L409.718 333.377L404.154 321.067Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L396.147 348.226L424.697 339.879L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L448.784 351.559L424.697 339.879L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M396.146 348.226L409.718 333.377L424.697 339.879L396.146 348.226Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M409.719 333.377L420.023 334.541L424.698 339.879L409.719 333.377Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M420.022 334.541L423.419 337.372L424.697 339.879L420.022 334.541Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M423.419 337.372L433.077 337.016L424.697 339.88L423.419 337.372Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M433.157 340.947L433.077 337.016L424.697 339.88L433.157 340.947Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M433.157 340.947L448.783 351.559L424.697 339.879L433.157 340.947Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L307.097 352.885L316.884 432.051L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L326.056 455.296L316.884 432.051L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M307.097 352.885L344.625 374.335L316.883 432.051L307.097 352.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M326.056 455.296L339.627 437.583L316.884 432.051L326.056 455.296Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.884L280.73 503.614L298.96 444.927L271.17 507.884Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M280.73 503.614L292.668 502.53L298.96 444.927L280.73 503.614Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M276.459 361.167L316.884 432.051L298.96 444.927L276.459 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L316.884 432.051L298.96 444.927L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 432.051L339.627 437.583L356.305 419.595L316.884 432.051Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M316.884 432.051L344.626 374.334L356.305 419.595L316.884 432.051Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M339.627 437.583L374.325 442.29L356.305 419.595L339.627 437.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M344.626 374.334L394.481 407.754L356.305 419.595L344.626 374.334Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M374.325 442.29L392.2 454.795L381.459 428.557L374.325 442.29Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 419.595L374.325 442.29L381.459 428.557L356.305 419.595Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M356.305 419.595L394.481 407.754L381.459 428.557L356.305 419.595Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L406.418 501.899L404.898 444.749L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M406.418 501.899L424.487 504.973L404.898 444.749L406.418 501.899Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L445.257 451.3L404.898 444.749L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 502.53L298.96 444.927L305.382 449.311L292.668 502.53Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M292.668 502.53L313.907 494.329L305.382 449.311L292.668 502.53Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M298.96 444.927L307.663 448.583L305.382 449.311L298.96 444.927Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M307.663 448.583L326.055 455.296L305.382 449.311L307.663 448.583Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M313.907 494.329L326.055 455.296L305.382 449.311L313.907 494.329Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 428.557L392.2 454.795L404.332 438.521L381.459 428.557Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M381.459 428.557L394.481 407.754L404.332 438.521L381.459 428.557Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M392.199 454.794L404.898 444.749L404.332 438.521L392.199 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M394.48 407.754L445.257 451.3L404.332 438.521L394.48 407.754Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M404.898 444.749L445.257 451.3L404.332 438.521L404.898 444.749Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L453.07 335.479L481.492 337.34L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M448.784 351.559L511.66 372.798L481.492 337.34L448.784 351.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M453.07 335.48L461.708 326.842L481.492 337.34L453.07 335.48Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M461.708 326.841L482.381 326.793L481.492 337.34L461.708 326.841Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L484.193 332.39L481.492 337.34L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L456.241 324.205L464.636 312.962L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M438.366 305.926L512.275 258.417L464.636 312.962L438.366 305.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M456.241 324.205L461.514 321.892L464.636 312.962L456.241 324.205Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M461.514 321.892L482.381 326.793L464.636 312.962L461.514 321.892Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L499.01 316.926L464.636 312.962L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M499.01 316.926L514.992 288.261L464.636 312.962L499.01 316.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M512.275 258.417L514.992 288.261L464.636 312.962L512.275 258.417Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 337.34L484.193 332.39L497.377 333.555L481.492 337.34Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M481.492 337.34L511.66 372.798L497.377 333.555L481.492 337.34Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L484.193 332.39L497.377 333.555L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M482.381 326.793L499.01 316.926L497.377 333.555L482.381 326.793Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M499.011 316.926L514.992 288.261L497.377 333.555L499.011 316.926Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M511.66 372.798L514.992 288.261L497.377 333.555L511.66 372.798Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M369.731 605.523L415.267 577.555L354.995 571.359L369.731 605.523Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L363.988 527.458L354.994 571.359L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L288.495 514.161L308.666 575.129L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M305.496 603.485L369.731 605.523L308.666 575.128L305.496 603.485Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 514.161L315.444 522.961L308.666 575.129L288.495 514.161Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.236 528.962L308.666 575.128L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L347.052 536.84L308.666 575.128L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M369.731 605.523L354.995 571.359L308.666 575.128L369.731 605.523Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M347.052 536.84L354.995 571.36L308.666 575.129L347.052 536.84Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L231.069 509.632L209.733 418.738L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M231.069 509.632L271.17 507.885L209.733 418.738L231.069 509.632Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M253.409 358.013L276.46 361.167L209.733 418.738L253.409 358.013Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M271.17 507.885L298.961 444.927L209.733 418.738L271.17 507.885Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46 361.167L298.961 444.927L209.733 418.738L276.46 361.167Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 514.662L389.854 512.559L401.938 515.908L386.91 514.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M389.854 512.559L394.739 511.589L401.938 515.908L389.854 512.559Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M394.739 511.589L401.064 509.195L401.938 515.908L394.739 511.589Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M401.064 509.195L406.564 506.332L401.938 515.908L401.064 509.195Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M406.564 506.332L410.64 505.183L401.938 515.908L406.564 506.332Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M410.64 505.183L424.487 504.973L401.938 515.908L410.64 505.183Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M424.487 504.973L415.267 577.555L401.938 515.908L424.487 504.973Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M354.995 571.36L415.267 577.555L382.672 525.775L354.995 571.36Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M386.91 514.662L401.938 515.908L382.672 525.775L386.91 514.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M401.938 515.908L415.267 577.555L382.672 525.775L401.938 515.908Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 527.458L354.995 571.36L382.672 525.775L363.989 527.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M363.989 527.458L365.865 522.055L382.672 525.775L363.989 527.458Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M365.865 522.055L370.152 517.493L382.672 525.775L365.865 522.055Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M370.152 517.493L386.91 514.662L382.672 525.775L370.152 517.493Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M372.303 495.057L373.371 498.098L382.267 492.323L372.303 495.057Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M373.371 498.098L385.017 496.788L382.267 492.323L373.371 498.098Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M385.018 496.788L398.153 500.298L382.268 492.323L385.018 496.788Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M392.2 454.794L398.153 500.298L382.268 492.323L392.2 454.794Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 489.007L392.2 454.794L382.268 492.323L361.028 489.007Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M361.028 489.007L365.461 491.741L382.268 492.323L361.028 489.007Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M365.46 491.741L372.303 495.057L382.267 492.323L365.46 491.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.236 528.962L327.641 524.74L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M315.444 522.96L327.172 516.668L327.641 524.74L315.444 522.96Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M327.236 528.962L340.824 523.025L327.641 524.74L327.236 528.962Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M327.172 516.668L340.824 523.025L327.641 524.74L327.172 516.668Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 329.155L221.073 321.698L223.806 331.662L208.148 329.155Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M221.073 321.698L237.443 331.986L223.806 331.662L221.073 321.698Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 335.625L237.443 331.985L223.806 331.662L232.024 335.625Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L198.038 330.077L227.025 341.044L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M171.46 345.816L209.733 418.738L227.025 341.044L171.46 345.816Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M198.038 330.077L208.148 329.155L227.025 341.044L198.038 330.077Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M209.733 418.738L253.409 358.013L227.025 341.044L209.733 418.738Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M208.148 329.155L223.806 331.662L227.025 341.044L208.148 329.155Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M223.806 331.662L232.024 335.625L227.025 341.044L223.806 331.662Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M232.024 335.625L239.966 336.741L227.025 341.044L232.024 335.625Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M239.966 336.741L253.409 358.013L227.025 341.044L239.966 336.741Z",
    stroke: "white",
    strokeWidth: 0.242642,
    strokeMiterlimit: 10
  })))), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M171.994 569.823H145.627V532.262",
    stroke: "white",
    strokeWidth: 3.23522,
    strokeMiterlimit: 10
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M540.826 532.262V569.823H514.847",
    stroke: "white",
    strokeWidth: 3.23522,
    strokeMiterlimit: 10
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M514.847 102.932H540.826V138.697",
    stroke: "white",
    strokeWidth: 3.23522,
    strokeMiterlimit: 10
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M145.627 139.635V102.932H171.994",
    stroke: "white",
    strokeWidth: 3.23522,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_196",
    x: 0,
    y: 0,
    width: 713,
    height: 713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 107,
    result: "effect1_foregroundBlur_0_196"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_196",
    x1: 317.521,
    y1: 693.201,
    x2: 343.457,
    y2: 649.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_196",
    x1: 61019.2,
    y1: 31348.8,
    x2: 69289,
    y2: 17303.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_196",
    x1: -102432,
    y1: -153646,
    x2: -105190,
    y2: -158773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_196",
    x1: -131774,
    y1: -206091,
    x2: -138359,
    y2: -218331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_196",
    x1: -140397,
    y1: -48708.9,
    x2: -146879,
    y2: -60756.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_196",
    x1: 2044.64,
    y1: 12440.5,
    x2: 4150.65,
    y2: 12440.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_196",
    x1: -140076,
    y1: -151475,
    x2: -146543,
    y2: -163496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_196",
    x1: 10934,
    y1: 18743.8,
    x2: 15038.9,
    y2: 18743.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_196",
    x1: -159068,
    y1: -195611,
    x2: -168064,
    y2: -212331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_196",
    x1: -171316,
    y1: -220453,
    x2: -180176,
    y2: -236921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_196",
    x1: -180614,
    y1: -245751,
    x2: -185529,
    y2: -254886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_196",
    x1: -136426,
    y1: -133059,
    x2: -145250,
    y2: -149462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_196",
    x1: 26990.4,
    y1: 13219.7,
    x2: 35129.1,
    y2: 13219.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_196",
    x1: -132985,
    y1: -214821,
    x2: -150564,
    y2: -208276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_196",
    x1: -134652,
    y1: -260526,
    x2: -153763,
    y2: -253410,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_196",
    x1: -18960.9,
    y1: 2308.15,
    x2: -22734.8,
    y2: 3713.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_0_196",
    x1: -126594,
    y1: -238962,
    x2: -145774,
    y2: -231821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_0_196",
    x1: -100471,
    y1: -71890.5,
    x2: -132731,
    y2: -59878.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_0_196",
    x1: -54297.3,
    y1: -88452.2,
    x2: -57347.8,
    y2: -87316.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_0_196",
    x1: -56782.3,
    y1: -95162.1,
    x2: -60870.9,
    y2: -93639.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_0_196",
    x1: -158283,
    y1: -79993.3,
    x2: -176485,
    y2: -72184.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_0_196",
    x1: -156444,
    y1: -75771.4,
    x2: -174714,
    y2: -67933.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FB7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_0_196",
    x1: 117.48,
    y1: 404.237,
    x2: 130.938,
    y2: 456.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26D3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5BDEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B1EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_0_196",
    x1: 99797.2,
    y1: 22379.1,
    x2: 101374,
    y2: 16758.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26D3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5BDEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B1EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_0_196",
    x1: 107281,
    y1: 5943.94,
    x2: 107676,
    y2: 3381.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26D3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5BDEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B1EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_0_196",
    x1: 93590.5,
    y1: 22897.7,
    x2: 95548.6,
    y2: 18497.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26D3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5BDEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B1EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_0_196",
    x1: 64216.3,
    y1: 41887.6,
    x2: 67229.8,
    y2: 35903.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#26D3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5BDEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B1EFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.752 297.968) rotate(-137.42) scale(16.1267 0.798353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(493.638 -115.75) rotate(132.58) scale(222.368 11.9729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1125.81 322.428) rotate(177.709) scale(764.283 2.54952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4919 661.827) rotate(87.7094) scale(103.668 77.1557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2552.67 -2477.48) rotate(-137.42) scale(142.061 6.48962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-587.141 782.615) rotate(132.581) scale(131.114 7.0327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5560.62 488.11) rotate(177.709) scale(450.955 1.51089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-394.372 461.689) rotate(87.7094) scale(60.9536 45.4497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-575.201 -396.371) rotate(-137.42) scale(92.2842 4.20091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1019.88 1800.47) rotate(132.58) scale(84.8583 4.56777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3076.67 643.565) rotate(177.709) scale(291.71 0.976855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-88.1395 1049.58) rotate(87.7094) scale(39.2052 29.4534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1485.07 -1822.74) rotate(-137.42) scale(121.512 5.53117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(630.903 -275.006) rotate(132.581) scale(111.741 6.01544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-880.242 256.231) rotate(177.709) scale(384.639 1.26039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.154 561.906) rotate(87.7094) scale(52.2452 38.8018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFFFD5",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_0_196",
    x1: 334.141,
    y1: 339.124,
    x2: 385.761,
    y2: 387.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_0_196",
    x1: 325.431,
    y1: 172.866,
    x2: 455.825,
    y2: 239.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A4F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_0_196",
    x1: 270.826,
    y1: 157.989,
    x2: 391.64,
    y2: 210.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2089CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_0_196",
    x1: 226.211,
    y1: 151.692,
    x2: 327.758,
    y2: 248.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A1ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_0_196",
    x1: 176.005,
    y1: 166.748,
    x2: 270.622,
    y2: 240.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#259CE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_0_196",
    x1: 344.121,
    y1: 134.565,
    x2: 419.617,
    y2: 218.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2395DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_0_196",
    x1: 415.9,
    y1: 214.671,
    x2: 510.743,
    y2: 267.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7DB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_0_196",
    x1: 428.312,
    y1: 364.136,
    x2: 528.24,
    y2: 424.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B73AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7DB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_0_196",
    x1: 393.413,
    y1: 350.959,
    x2: 484.329,
    y2: 394.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F85C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_0_196",
    x1: 347.405,
    y1: 353.244,
    x2: 410.431,
    y2: 400.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_0_196",
    x1: 356.985,
    y1: 452.572,
    x2: 368.048,
    y2: 476.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3C59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_0_196",
    x1: 334.979,
    y1: 448.92,
    x2: 355.974,
    y2: 477.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_0_196",
    x1: 345.562,
    y1: 458.291,
    x2: 350.627,
    y2: 475.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C324A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_0_196",
    x1: 324.2,
    y1: 454.45,
    x2: 344.699,
    y2: 478.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_0_196",
    x1: 334.719,
    y1: 458.589,
    x2: 345.433,
    y2: 478.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09283C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_0_196",
    x1: 216.266,
    y1: 489.041,
    x2: 358.774,
    y2: 572.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11496C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_0_196",
    x1: 161.358,
    y1: 246.116,
    x2: 214.401,
    y2: 254.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18689A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2088C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_0_196",
    x1: 160,
    y1: 236.379,
    x2: 213.821,
    y2: 243.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17618F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_0_196",
    x1: 176.503,
    y1: 160.374,
    x2: 256.958,
    y2: 220.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2290D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C79B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_0_196",
    x1: 161.224,
    y1: 139.879,
    x2: 254.433,
    y2: 212.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F85C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_0_196",
    x1: 229.116,
    y1: 139.596,
    x2: 268.683,
    y2: 210.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218BCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_0_196",
    x1: 253.486,
    y1: 120.151,
    x2: 310.883,
    y2: 194.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19699B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_0_196",
    x1: 293.01,
    y1: 133.495,
    x2: 345.708,
    y2: 217.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2089C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_0_196",
    x1: 320.18,
    y1: 109.014,
    x2: 349.885,
    y2: 179.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_0_196",
    x1: 430.421,
    y1: 243.823,
    x2: 519.682,
    y2: 313.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B73AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_0_196",
    x1: 397.854,
    y1: 159.243,
    x2: 469.996,
    y2: 228.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_0_196",
    x1: 432.712,
    y1: 209.538,
    x2: 442.385,
    y2: 240.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F85C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_0_196",
    x1: 424.064,
    y1: 127.484,
    x2: 505.928,
    y2: 182.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3A55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_0_196",
    x1: 488.833,
    y1: 202.513,
    x2: 522.215,
    y2: 208.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C76AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_0_196",
    x1: 406.781,
    y1: 517.376,
    x2: 469.2,
    y2: 563.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155984"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_0_196",
    x1: 411.656,
    y1: 474.01,
    x2: 463.036,
    y2: 531.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F83C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_0_196",
    x1: 443.288,
    y1: 383.855,
    x2: 529.176,
    y2: 431.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18689A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_0_196",
    x1: 344.709,
    y1: 538.276,
    x2: 352.991,
    y2: 551.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_0_196",
    x1: 334.378,
    y1: 514.124,
    x2: 340.306,
    y2: 522.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_0_196",
    x1: 347.891,
    y1: 521.635,
    x2: 356.588,
    y2: 530.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134F75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_0_196",
    x1: 292.978,
    y1: 512.251,
    x2: 299.485,
    y2: 513.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F4261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_0_196",
    x1: 203.377,
    y1: 437.049,
    x2: 470.973,
    y2: 576.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F4160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_0_196",
    x1: 267.881,
    y1: 512.087,
    x2: 274.975,
    y2: 524.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_0_196",
    x1: 285.573,
    y1: 514.356,
    x2: 295.135,
    y2: 524.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11496C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6FA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_0_196",
    x1: 293.935,
    y1: 528.311,
    x2: 303.386,
    y2: 546.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C76AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C76AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_0_196",
    x1: 318.403,
    y1: 522.084,
    x2: 331.941,
    y2: 534.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19699B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_0_196",
    x1: 336.358,
    y1: 523.312,
    x2: 351.624,
    y2: 540.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_0_196",
    x1: 331.801,
    y1: 515.544,
    x2: 345.647,
    y2: 521.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F405E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_0_196",
    x1: 348.451,
    y1: 521.617,
    x2: 364.705,
    y2: 533.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3C59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_0_196",
    x1: 338.727,
    y1: 518.999,
    x2: 349.129,
    y2: 527.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196A9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_0_196",
    x1: 340.616,
    y1: 523.421,
    x2: 349.012,
    y2: 534.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_0_196",
    x1: 344.607,
    y1: 526.926,
    x2: 351.681,
    y2: 535.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#145780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_0_196",
    x1: 350.001,
    y1: 518.271,
    x2: 361.032,
    y2: 526.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6DA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_0_196",
    x1: 390.847,
    y1: 509.983,
    x2: 395.663,
    y2: 516.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_0_196",
    x1: 395.262,
    y1: 508.018,
    x2: 398.845,
    y2: 509.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18689A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_0_196",
    x1: 319.591,
    y1: 509.2,
    x2: 322.608,
    y2: 509.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B72A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_0_196",
    x1: 324.841,
    y1: 521.075,
    x2: 335.724,
    y2: 532.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B74AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6EA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_0_196",
    x1: 326.139,
    y1: 515.321,
    x2: 336.184,
    y2: 526.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14567F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134F75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_0_196",
    x1: 323.95,
    y1: 514.981,
    x2: 333.53,
    y2: 527.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_0_196",
    x1: 322.131,
    y1: 509.804,
    x2: 338.662,
    y2: 523.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_0_196",
    x1: 373.321,
    y1: 507.149,
    x2: 387.422,
    y2: 516.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2E44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_0_196",
    x1: 345.134,
    y1: 515.353,
    x2: 349.836,
    y2: 518.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_0_196",
    x1: 320.208,
    y1: 506.381,
    x2: 328.656,
    y2: 517.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_0_196",
    x1: 300.493,
    y1: 510.699,
    x2: 311.537,
    y2: 516.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2B3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_0_196",
    x1: 301.64,
    y1: 518.39,
    x2: 324.061,
    y2: 531.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A70A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14547C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_0_196",
    x1: 299.946,
    y1: 507.424,
    x2: 300.951,
    y2: 509.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_0_196",
    x1: 301.362,
    y1: 505.712,
    x2: 302.899,
    y2: 509.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_0_196",
    x1: 310.434,
    y1: 498.359,
    x2: 325.518,
    y2: 502.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11496C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_0_196",
    x1: 318.044,
    y1: 502.471,
    x2: 339.302,
    y2: 512.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19699B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_0_196",
    x1: 317.672,
    y1: 507.081,
    x2: 329.002,
    y2: 520.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C334B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_0_196",
    x1: 329.11,
    y1: 511.086,
    x2: 332.217,
    y2: 518.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_0_196",
    x1: 317.703,
    y1: 501.19,
    x2: 321.973,
    y2: 509.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_0_196",
    x1: 332.205,
    y1: 504.784,
    x2: 337.956,
    y2: 508.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_0_196",
    x1: 329.089,
    y1: 506.415,
    x2: 335.236,
    y2: 512.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_0_196",
    x1: 339.39,
    y1: 503.331,
    x2: 344.998,
    y2: 504.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_0_196",
    x1: 340.041,
    y1: 511.797,
    x2: 351.54,
    y2: 521.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_0_196",
    x1: 345.465,
    y1: 506.945,
    x2: 356.973,
    y2: 518.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_0_196",
    x1: 363.103,
    y1: 503.16,
    x2: 376.226,
    y2: 516.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_0_196",
    x1: 354.765,
    y1: 517.026,
    x2: 364.232,
    y2: 520.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C354E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_0_196",
    x1: 352.516,
    y1: 508.914,
    x2: 361.559,
    y2: 512.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_0_196",
    x1: 359.883,
    y1: 514.726,
    x2: 373.334,
    y2: 524.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_0_196",
    x1: 357.116,
    y1: 506.637,
    x2: 360.653,
    y2: 506.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_0_196",
    x1: 356.741,
    y1: 506.682,
    x2: 367.067,
    y2: 519.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_0_196",
    x1: 363.485,
    y1: 509.551,
    x2: 377.311,
    y2: 522.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14567F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_0_196",
    x1: 332.05,
    y1: 492.359,
    x2: 339.83,
    y2: 500.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_0_196",
    x1: 336.32,
    y1: 495.243,
    x2: 344.175,
    y2: 505.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_0_196",
    x1: -159997,
    y1: -150861,
    x2: -159971,
    y2: -150800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_0_196",
    x1: 324.997,
    y1: 493.51,
    x2: 337.405,
    y2: 505.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11486B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_0_196",
    x1: 327.293,
    y1: 460.16,
    x2: 359.705,
    y2: 479.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_0_196",
    x1: 337.037,
    y1: 495.816,
    x2: 349.242,
    y2: 504.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7BB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_0_196",
    x1: 329.931,
    y1: 470.714,
    x2: 352.823,
    y2: 481.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165E8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_0_196",
    x1: 299.376,
    y1: 496.369,
    x2: 305.521,
    y2: 504.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09283A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_0_196",
    x1: 305.466,
    y1: 498.068,
    x2: 313.575,
    y2: 508.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09283C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_0_196",
    x1: 313.846,
    y1: 496.131,
    x2: 322.048,
    y2: 505.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_0_196",
    x1: 313.989,
    y1: 494.746,
    x2: 321.042,
    y2: 509.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124F74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_0_196",
    x1: 305.31,
    y1: 462.547,
    x2: 341.255,
    y2: 481.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_0_196",
    x1: 283.485,
    y1: 515.494,
    x2: 295.623,
    y2: 526.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14547C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_0_196",
    x1: 287.428,
    y1: 518.2,
    x2: 298.766,
    y2: 525.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_0_196",
    x1: 298.263,
    y1: 516.618,
    x2: 300.072,
    y2: 520.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_0_196",
    x1: 298.641,
    y1: 506.996,
    x2: 299.138,
    y2: 509.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_0_196",
    x1: 285.437,
    y1: 505.638,
    x2: 289.742,
    y2: 516.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_0_196",
    x1: 266.171,
    y1: 509.94,
    x2: 273.988,
    y2: 519.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13527A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_0_196",
    x1: 277.452,
    y1: 508.969,
    x2: 284.468,
    y2: 518.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2E44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_0_196",
    x1: 333.314,
    y1: 474.116,
    x2: 356.431,
    y2: 484.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_0_196",
    x1: 342.984,
    y1: 493.151,
    x2: 349.399,
    y2: 504.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A70A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_0_196",
    x1: 354.247,
    y1: 463.261,
    x2: 387.38,
    y2: 500.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B72A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_0_196",
    x1: 355.267,
    y1: 497.436,
    x2: 362.509,
    y2: 508.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09283C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_0_196",
    x1: 352.315,
    y1: 498.22,
    x2: 359.837,
    y2: 504.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C354E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13527A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_0_196",
    x1: 358.862,
    y1: 499.089,
    x2: 366.924,
    y2: 505.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A293D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_0_196",
    x1: 377.678,
    y1: 494.306,
    x2: 392.407,
    y2: 505.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_0_196",
    x1: 384.152,
    y1: 501.141,
    x2: 395.699,
    y2: 506.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C354E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2E44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_0_196",
    x1: 386.739,
    y1: 503.011,
    x2: 399.943,
    y2: 514.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C334C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_0_196",
    x1: 390.029,
    y1: 478.247,
    x2: 409.173,
    y2: 480.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E82BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11486B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_0_196",
    x1: 403.515,
    y1: 507.186,
    x2: 405.445,
    y2: 511.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_0_196",
    x1: -15837.7,
    y1: -54341.6,
    x2: -15823.7,
    y2: -54329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_0_196",
    x1: 414.922,
    y1: 508.697,
    x2: 419.668,
    y2: 512.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_0_196",
    x1: 412.896,
    y1: 505.135,
    x2: 415.978,
    y2: 513.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3C58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_0_196",
    x1: 391.154,
    y1: 503.391,
    x2: 401.013,
    y2: 511.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_0_196",
    x1: 395.237,
    y1: 500.385,
    x2: 401.326,
    y2: 502.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A293D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_0_196",
    x1: 393.998,
    y1: 509.764,
    x2: 400.9,
    y2: 514.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2C42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_0_196",
    x1: 392.747,
    y1: 515.15,
    x2: 393.599,
    y2: 517.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6FA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18689A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_0_196",
    x1: 394.901,
    y1: 521.465,
    x2: 399.14,
    y2: 523.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17608E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_0_196",
    x1: 399.171,
    y1: 522.923,
    x2: 402.854,
    y2: 529.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3D5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13537B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_0_196",
    x1: 367.021,
    y1: 517.081,
    x2: 373.298,
    y2: 527.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11496C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155B86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_0_196",
    x1: 391.028,
    y1: 523.689,
    x2: 396.384,
    y2: 528.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B72A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_0_196",
    x1: 364.58,
    y1: 522.633,
    x2: 371.274,
    y2: 534.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165D8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_0_196",
    x1: 355.618,
    y1: 519.824,
    x2: 366.904,
    y2: 529.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F415F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_0_196",
    x1: 349.381,
    y1: 526.447,
    x2: 353.963,
    y2: 534.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C344D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3A55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_0_196",
    x1: 352.937,
    y1: 525.643,
    x2: 359.112,
    y2: 534.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_0_196",
    x1: 253.442,
    y1: 326.257,
    x2: 268.736,
    y2: 339.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_0_196",
    x1: 265.559,
    y1: 321.427,
    x2: 267.607,
    y2: 325.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_0_196",
    x1: 198.323,
    y1: 233.33,
    x2: 283.753,
    y2: 308.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2395DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F85C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_0_196",
    x1: 259.329,
    y1: 312.885,
    x2: 270.339,
    y2: 317.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09283A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_0_196",
    x1: 257.816,
    y1: 311.195,
    x2: 269.657,
    y2: 321.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_0_196",
    x1: 193.322,
    y1: 252.177,
    x2: 281.652,
    y2: 299.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249AE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_0_196",
    x1: 230.2,
    y1: 333.338,
    x2: 242.518,
    y2: 337.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_0_196",
    x1: -160614,
    y1: -910675,
    x2: -160505,
    y2: -910648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_0_196",
    x1: 233.855,
    y1: 321.565,
    x2: 250.413,
    y2: 341.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_0_196",
    x1: 242.992,
    y1: 309.899,
    x2: 255.721,
    y2: 328.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09283C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_0_196",
    x1: 179.036,
    y1: 256.711,
    x2: 224.294,
    y2: 263.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_0_196",
    x1: 184.707,
    y1: 239.255,
    x2: 258.804,
    y2: 267.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2397DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_0_196",
    x1: 217.075,
    y1: 319.198,
    x2: 235.152,
    y2: 336.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_0_196",
    x1: 190.641,
    y1: 332.333,
    x2: 194.739,
    y2: 343.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A293D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_0_196",
    x1: 239.348,
    y1: 340.188,
    x2: 245.684,
    y2: 348.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_0_196",
    x1: 241.322,
    y1: 340.788,
    x2: 248.531,
    y2: 347.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_0_196",
    x1: 248.573,
    y1: 343.541,
    x2: 255.151,
    y2: 351.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_0_196",
    x1: 257.124,
    y1: 328.107,
    x2: 271.511,
    y2: 341.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_0_196",
    x1: 253.584,
    y1: 330.444,
    x2: 261.056,
    y2: 341.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_0_196",
    x1: 267.702,
    y1: 318.002,
    x2: 279.476,
    y2: 323.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_0_196",
    x1: 269.893,
    y1: 322.317,
    x2: 282.453,
    y2: 327.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_0_196",
    x1: -924932,
    y1: -466386,
    x2: -924874,
    y2: -466190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_0_196",
    x1: 252.32,
    y1: 312.773,
    x2: 259.159,
    y2: 326.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_0_196",
    x1: 255.081,
    y1: 250.766,
    x2: 296.786,
    y2: 259.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C79B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C79B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_0_196",
    x1: 272.874,
    y1: 321.898,
    x2: 273.818,
    y2: 325.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_0_196",
    x1: 265.092,
    y1: 324.817,
    x2: 279.807,
    y2: 331.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_0_196",
    x1: 261.586,
    y1: 324.995,
    x2: 278.591,
    y2: 346.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_0_196",
    x1: 277.386,
    y1: 268.896,
    x2: 293.333,
    y2: 269.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176290"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C77B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_0_196",
    x1: 286.659,
    y1: 307.491,
    x2: 302.095,
    y2: 320.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_0_196",
    x1: 262.469,
    y1: 263.173,
    x2: 348.998,
    y2: 330.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_0_196",
    x1: 271.72,
    y1: 263.38,
    x2: 314.726,
    y2: 270.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_0_196",
    x1: 292.594,
    y1: 313.559,
    x2: 308.111,
    y2: 327.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_0_196",
    x1: 305.955,
    y1: 307.668,
    x2: 324.556,
    y2: 343.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_0_196",
    x1: -255839,
    y1: -527040,
    x2: -255727,
    y2: -526918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_0_196",
    x1: 289.504,
    y1: 324.849,
    x2: 298.386,
    y2: 337.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_0_196",
    x1: -326590,
    y1: -449245,
    x2: -326503,
    y2: -449106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_0_196",
    x1: 299.165,
    y1: 340.127,
    x2: 311.151,
    y2: 349.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_0_196",
    x1: 316.988,
    y1: 339.342,
    x2: 320.339,
    y2: 346.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_0_196",
    x1: 300.336,
    y1: 343.816,
    x2: 320.812,
    y2: 360.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_0_196",
    x1: 297.447,
    y1: 335.406,
    x2: 306.899,
    y2: 349.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_0_196",
    x1: 306.392,
    y1: 339.091,
    x2: 313.419,
    y2: 347.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_0_196",
    x1: 302.621,
    y1: 343.634,
    x2: 323.207,
    y2: 363.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2E44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_0_196",
    x1: 311.11,
    y1: 339.584,
    x2: 318.099,
    y2: 347.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_0_196",
    x1: 321.417,
    y1: 313.968,
    x2: 355.076,
    y2: 356.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#134F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F415F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_0_196",
    x1: 297.993,
    y1: 352.533,
    x2: 315.389,
    y2: 374.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104362"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_0_196",
    x1: 309.717,
    y1: 335.505,
    x2: 351.359,
    y2: 366.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7EBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_0_196",
    x1: 320.257,
    y1: 311.131,
    x2: 353.457,
    y2: 343.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_0_196",
    x1: 319.557,
    y1: 337.443,
    x2: 329.111,
    y2: 347.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3C59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_0_196",
    x1: 327.486,
    y1: 338.398,
    x2: 379.1,
    y2: 384.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_0_196",
    x1: 295.122,
    y1: 340.009,
    x2: 304.324,
    y2: 341.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F415F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_0_196",
    x1: 272.003,
    y1: 361.028,
    x2: 278.07,
    y2: 376.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F4160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C344D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_0_196",
    x1: 250.098,
    y1: 343.375,
    x2: 273.057,
    y2: 356.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_0_196",
    x1: 248.986,
    y1: 354.21,
    x2: 265.679,
    y2: 373.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F405E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_0_196",
    x1: 259.889,
    y1: 346.716,
    x2: 272.008,
    y2: 358.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_0_196",
    x1: 258.919,
    y1: 340.18,
    x2: 272.024,
    y2: 344.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_0_196",
    x1: 254.834,
    y1: 342.332,
    x2: 269.783,
    y2: 367.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2B3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_0_196",
    x1: 258.718,
    y1: 354.236,
    x2: 273.254,
    y2: 378.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C334B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_0_196",
    x1: 274.89,
    y1: 343.792,
    x2: 285.32,
    y2: 365.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09283C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3D5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_0_196",
    x1: 245.135,
    y1: 343.993,
    x2: 250.739,
    y2: 350.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_0_196",
    x1: 230.98,
    y1: 335.085,
    x2: 235.403,
    y2: 344.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_0_196",
    x1: 246.736,
    y1: 336.119,
    x2: 269.316,
    y2: 347.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2A3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_0_196",
    x1: 238.437,
    y1: 344.122,
    x2: 243.496,
    y2: 350.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_0_196",
    x1: 355.625,
    y1: 313.635,
    x2: 376.112,
    y2: 347.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3F5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_0_196",
    x1: 351.292,
    y1: 226.031,
    x2: 455.23,
    y2: 289.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C79B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C76AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_0_196",
    x1: 376.379,
    y1: 320.499,
    x2: 397.137,
    y2: 327.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D364F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_0_196",
    x1: -411045,
    y1: -112091,
    x2: -411032,
    y2: -112033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_0_196",
    x1: 434.195,
    y1: 342.98,
    x2: 444.511,
    y2: 355.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C354E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104464"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_0_196",
    x1: 424.071,
    y1: 345.403,
    x2: 426.58,
    y2: 351.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_0_196",
    x1: 383.909,
    y1: 325.777,
    x2: 391.575,
    y2: 326.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_0_196",
    x1: -118074,
    y1: -131272,
    x2: -118050,
    y2: -131223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_0_196",
    x1: -87335.7,
    y1: -131739,
    x2: -87308.6,
    y2: -131696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_0_196",
    x1: 400.941,
    y1: 316.601,
    x2: 411.987,
    y2: 333.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_0_196",
    x1: 394.711,
    y1: 219.575,
    x2: 456.067,
    y2: 233.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17608E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C79B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_0_196",
    x1: 398.516,
    y1: 309.666,
    x2: 424.989,
    y2: 325.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_0_196",
    x1: 405.141,
    y1: 228.885,
    x2: 436.714,
    y2: 231.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_0_196",
    x1: -489641,
    y1: -2348670,
    x2: -489322,
    y2: -2348560,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_0_196",
    x1: 413.07,
    y1: 319.266,
    x2: 438.512,
    y2: 334.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_0_196",
    x1: 431.837,
    y1: 318.709,
    x2: 435.392,
    y2: 327.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2D43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_0_196",
    x1: 420.935,
    y1: 320.974,
    x2: 441.927,
    y2: 328.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_0_196",
    x1: 432.095,
    y1: 314.195,
    x2: 454.485,
    y2: 330.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2D43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_0_196",
    x1: 431.482,
    y1: 320.418,
    x2: 452.723,
    y2: 337.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_0_196",
    x1: 466.557,
    y1: 334.566,
    x2: 472.251,
    y2: 339.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_0_196",
    x1: 451.617,
    y1: 336.315,
    x2: 456.692,
    y2: 348.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09283C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_0_196",
    x1: 442.76,
    y1: 346.302,
    x2: 452.969,
    y2: 352.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_0_196",
    x1: 447.835,
    y1: 327.58,
    x2: 460.43,
    y2: 338.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_0_196",
    x1: 440.676,
    y1: 337.925,
    x2: 451.005,
    y2: 340.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_0_196",
    x1: 454.434,
    y1: 330.719,
    x2: 465.963,
    y2: 338.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C324A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A2C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_0_196",
    x1: 434.348,
    y1: 350.333,
    x2: 437.185,
    y2: 357.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_0_196",
    x1: 438.193,
    y1: 345.884,
    x2: 451.082,
    y2: 359.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17608E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_0_196",
    x1: 384.371,
    y1: 323.653,
    x2: 407.594,
    y2: 334.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_0_196",
    x1: 400.505,
    y1: 324.575,
    x2: 414.331,
    y2: 337.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_0_196",
    x1: 409.718,
    y1: 324.021,
    x2: 425.715,
    y2: 337.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_0_196",
    x1: 396.457,
    y1: 355.637,
    x2: 455.913,
    y2: 383.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3B57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_0_196",
    x1: 394.916,
    y1: 358.698,
    x2: 464.103,
    y2: 411.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14547C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_0_196",
    x1: 398.057,
    y1: 340.748,
    x2: 410.295,
    y2: 361.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_0_196",
    x1: 405.507,
    y1: 333.721,
    x2: 413.089,
    y2: 345.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_0_196",
    x1: 416.061,
    y1: 339.061,
    x2: 421.944,
    y2: 342.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_0_196",
    x1: 426.95,
    y1: 343.216,
    x2: 428.684,
    y2: 347.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#080808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_0_196",
    x1: 429.052,
    y1: 343.102,
    x2: 432.546,
    y2: 349.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0A0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_0_196",
    x1: 431.222,
    y1: 350.394,
    x2: 446.294,
    y2: 369.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11486A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_0_196",
    x1: 278.711,
    y1: 345.079,
    x2: 337.669,
    y2: 364.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155B86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_0_196",
    x1: 312.126,
    y1: 447.726,
    x2: 337.283,
    y2: 462.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_0_196",
    x1: 304.981,
    y1: 362.615,
    x2: 365.885,
    y2: 383.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F83C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_0_196",
    x1: 323.498,
    y1: 445.498,
    x2: 349.116,
    y2: 465.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_0_196",
    x1: 264.21,
    y1: 449.061,
    x2: 317.232,
    y2: 472.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_0_196",
    x1: 271.25,
    y1: 452.962,
    x2: 312.373,
    y2: 465.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_0_196",
    x1: 278.783,
    y1: 375.923,
    x2: 339.716,
    y2: 392.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F3E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_0_196",
    x1: 293.05,
    y1: 432.264,
    x2: 309.899,
    y2: 449.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13537B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_0_196",
    x1: 312.493,
    y1: 432.481,
    x2: 327.717,
    y2: 460.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17618F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B74AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_0_196",
    x1: 316.078,
    y1: 384.455,
    x2: 371.432,
    y2: 417.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27A6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_0_196",
    x1: 340.802,
    y1: 427.615,
    x2: 366.32,
    y2: 457.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176392"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_0_196",
    x1: 331.545,
    y1: 386.189,
    x2: 381.576,
    y2: 431.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2395DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_0_196",
    x1: 367.17,
    y1: 431.274,
    x2: 393.221,
    y2: 443.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_0_196",
    x1: 363.651,
    y1: 424.6,
    x2: 389.794,
    y2: 446.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2292D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_0_196",
    x1: 358.796,
    y1: 421.553,
    x2: 377.063,
    y2: 451.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E80BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_0_196",
    x1: 386.664,
    y1: 435.66,
    x2: 412.588,
    y2: 439.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#218CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19699B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_0_196",
    x1: 401.257,
    y1: 469.689,
    x2: 434.79,
    y2: 475.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C79B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_0_196",
    x1: 408.83,
    y1: 452.403,
    x2: 467.579,
    y2: 482.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B74AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2087C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_0_196",
    x1: 279.358,
    y1: 454.557,
    x2: 311.798,
    y2: 461.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14557D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B75AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_0_196",
    x1: 287.408,
    y1: 456.104,
    x2: 325.57,
    y2: 468.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_0_196",
    x1: 306.172,
    y1: 456.948,
    x2: 311.126,
    y2: 463.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A6EA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16608D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_0_196",
    x1: 300.182,
    y1: 454.501,
    x2: 307.748,
    y2: 468.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11496C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_0_196",
    x1: 310.941,
    y1: 450.105,
    x2: 345.525,
    y2: 461.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17608E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_0_196",
    x1: 374.654,
    y1: 429.001,
    x2: 402.782,
    y2: 447.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14567E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_0_196",
    x1: 380.327,
    y1: 409.368,
    x2: 411.387,
    y2: 427.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F85C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7DB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_0_196",
    x1: 397.103,
    y1: 449.66,
    x2: 413.17,
    y2: 461.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E80BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_0_196",
    x1: 383.824,
    y1: 422.674,
    x2: 435.415,
    y2: 464.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E82BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_0_196",
    x1: 394.219,
    y1: 452.497,
    x2: 408.218,
    y2: 479.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F85C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E81BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_0_196",
    x1: 438.804,
    y1: 334.779,
    x2: 452.887,
    y2: 359.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16608D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14547C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_0_196",
    x1: 447.728,
    y1: 349.768,
    x2: 486.49,
    y2: 400.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C79B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C77B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_0_196",
    x1: 452.359,
    y1: 334.076,
    x2: 464.11,
    y2: 354.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F405E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_0_196",
    x1: -449477,
    y1: -370030,
    x2: -449420,
    y2: -369889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_0_196",
    x1: 481.479,
    y1: 328.183,
    x2: 487.309,
    y2: 329.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_0_196",
    x1: 439.289,
    y1: 313.832,
    x2: 460.48,
    y2: 336.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_0_196",
    x1: 438.995,
    y1: 264.967,
    x2: 490.351,
    y2: 330.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_0_196",
    x1: 457.292,
    y1: 316.339,
    x2: 468.382,
    y2: 324.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_0_196",
    x1: 451.934,
    y1: 320.949,
    x2: 469.528,
    y2: 339.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2E44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_0_196",
    x1: 456.519,
    y1: 317.387,
    x2: 470.251,
    y2: 341.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F415F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14547C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_0_196",
    x1: 459.748,
    y1: 290.078,
    x2: 485.465,
    y2: 330.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2290D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_0_196",
    x1: 458.172,
    y1: 264.363,
    x2: 512.302,
    y2: 311.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_0_196",
    x1: 485.157,
    y1: 336.763,
    x2: 488.418,
    y2: 345.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C79B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E81BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_0_196",
    x1: 483.438,
    y1: 334.447,
    x2: 522.491,
    y2: 355.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F84C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F86C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_0_196",
    x1: 474.681,
    y1: 338.664,
    x2: 482.615,
    y2: 350.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17618F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D7EBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_0_196",
    x1: 476.689,
    y1: 329.145,
    x2: 494.46,
    y2: 344.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2291D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_0_196",
    x1: 498.425,
    y1: 293.973,
    x2: 534.283,
    y2: 307.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E81BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_0_196",
    x1: 500.323,
    y1: 280.548,
    x2: 541.382,
    y2: 287.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E81BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E80BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_0_196",
    x1: 311.902,
    y1: 557.536,
    x2: 396.733,
    y2: 706.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_0_196",
    x1: 347.297,
    y1: 532.665,
    x2: 369.08,
    y2: 545.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F415F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_0_196",
    x1: 242.779,
    y1: 514.649,
    x2: 326.702,
    y2: 581.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_0_196",
    x1: 294.254,
    y1: 586.746,
    x2: 328.412,
    y2: 644.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F415F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_0_196",
    x1: 293.407,
    y1: 519.168,
    x2: 338.99,
    y2: 533.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_0_196",
    x1: 306.059,
    y1: 524.311,
    x2: 345.091,
    y2: 537.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3F5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_0_196",
    x1: 306.382,
    y1: 533.484,
    x2: 353.851,
    y2: 570.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_0_196",
    x1: 313.695,
    y1: 570.653,
    x2: 372.789,
    y2: 646.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165D8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_0_196",
    x1: 312.564,
    y1: 550.667,
    x2: 338.002,
    y2: 589.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B74AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_0_196",
    x1: 169.039,
    y1: 353.517,
    x2: 241.025,
    y2: 363.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_0_196",
    x1: 186.33,
    y1: 436.624,
    x2: 284.817,
    y2: 504.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135279"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_0_196",
    x1: 195.53,
    y1: 376.342,
    x2: 256.178,
    y2: 440.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17618F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165C88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_0_196",
    x1: 223.394,
    y1: 422.147,
    x2: 325.094,
    y2: 504.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14567E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_0_196",
    x1: 220.72,
    y1: 374.488,
    x2: 313.013,
    y2: 452.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_0_196",
    x1: 392.109,
    y1: 518.802,
    x2: 395.238,
    y2: 526.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6EA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_0_196",
    x1: 396.475,
    y1: 521.804,
    x2: 400.737,
    y2: 529.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196A9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_0_196",
    x1: 392.519,
    y1: 523.164,
    x2: 399.828,
    y2: 529.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#186595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_0_196",
    x1: 399.594,
    y1: 511.172,
    x2: 408.187,
    y2: 515.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_0_196",
    x1: 400.286,
    y1: 520.903,
    x2: 410.94,
    y2: 529.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D3853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11486B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_0_196",
    x1: 401.585,
    y1: 519.453,
    x2: 410.109,
    y2: 535.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C344D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14557D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_0_196",
    x1: 404.639,
    y1: 513.723,
    x2: 437.972,
    y2: 527.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_0_196",
    x1: 361.359,
    y1: 545.503,
    x2: 405.287,
    y2: 588.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F415F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_0_196",
    x1: 379.28,
    y1: 527.123,
    x2: 389.54,
    y2: 542.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C77AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_0_196",
    x1: 385.223,
    y1: 522.077,
    x2: 432.8,
    y2: 560.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3D5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_0_196",
    x1: 359.495,
    y1: 535.571,
    x2: 380.123,
    y2: 542.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_0_196",
    x1: 349.624,
    y1: 528.886,
    x2: 353.152,
    y2: 538.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F4261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_0_196",
    x1: 364.907,
    y1: 531.61,
    x2: 374.169,
    y2: 544.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#135279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124F74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_0_196",
    x1: 376.071,
    y1: 526.863,
    x2: 386.978,
    y2: 541.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#145780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_0_196",
    x1: 380.684,
    y1: 504.084,
    x2: 385.256,
    y2: 511.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C334C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_0_196",
    x1: 378.06,
    y1: 503.541,
    x2: 382.738,
    y2: 511.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C334C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_0_196",
    x1: 380.934,
    y1: 502.458,
    x2: 391.26,
    y2: 515.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165C88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_0_196",
    x1: 373.956,
    y1: 462.921,
    x2: 401.732,
    y2: 469.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#218BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B72A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_0_196",
    x1: 350.535,
    y1: 459.709,
    x2: 389.597,
    y2: 490.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F83C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_0_196",
    x1: 353.384,
    y1: 493.599,
    x2: 356.691,
    y2: 503.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18689A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17618F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_0_196",
    x1: 371.095,
    y1: 498.557,
    x2: 373.478,
    y2: 505.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_0_196",
    x1: 313.427,
    y1: 527.423,
    x2: 320.443,
    y2: 537.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14547C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_0_196",
    x1: 312.189,
    y1: 528.08,
    x2: 320.543,
    y2: 538.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124E73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_0_196",
    x1: 334.176,
    y1: 523.733,
    x2: 337.717,
    y2: 531.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3F5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_0_196",
    x1: 321.665,
    y1: 529.674,
    x2: 329.815,
    y2: 540.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#155984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104667"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_0_196",
    x1: 208.316,
    y1: 332.528,
    x2: 218.833,
    y2: 345.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09283C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_0_196",
    x1: 220.761,
    y1: 327.759,
    x2: 233.277,
    y2: 341.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_0_196",
    x1: 230.347,
    y1: 331.107,
    x2: 234.335,
    y2: 339.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_0_196",
    x1: 165.914,
    y1: 341.09,
    x2: 175.246,
    y2: 367.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B72A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14567E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_0_196",
    x1: 167.98,
    y1: 341.47,
    x2: 244.521,
    y2: 387.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2290D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B72A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_0_196",
    x1: 206.466,
    y1: 333.233,
    x2: 218.971,
    y2: 353.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3B57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_0_196",
    x1: 209.061,
    y1: 358.321,
    x2: 281.441,
    y2: 396.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C77AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_0_196",
    x1: 216.68,
    y1: 332.06,
    x2: 231.148,
    y2: 347.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C354E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_0_196",
    x1: 221.616,
    y1: 338.472,
    x2: 231.633,
    y2: 345.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D364F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_0_196",
    x1: 233.777,
    y1: 346.094,
    x2: 237.76,
    y2: 354.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D3650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_0_196",
    x1: 232.907,
    y1: 339.053,
    x2: 257.173,
    y2: 361.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135279"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint363_radial_0_196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.599 273.094) scale(147.025 245.531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 667.41,
    height: 701.59,
    fill: "white",
    transform: "translate(13.9053 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIllustration);
export default __webpack_public_path__ + "static/media/Header_Illustration.d75432a84e5d06f85ec67dc1bbf1735c.svg";
export { ForwardRef as ReactComponent };